import React, { Component, Fragment } from 'react'
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';
import { ReactComponent as Back } from 'Icons/back.svg';
import { ReactComponent as Open } from 'Icons/open.svg';
import { ReactComponent as UpArrow } from 'Icons/uparrow.svg';
import { ReactComponent as DownArrow } from 'Icons/d-arrow.svg';
import { formatToINR } from 'Utils/transform';
import LineItemDetail from '../LineItemDetail/index';
import PostBidPopup from 'Components/PostBidPopup/index';
import OutsideClickHandler from 'react-outside-click-handler';
import { Status } from 'Components/Status';
import ConfirmationPopup from 'Components/ConfirmationPopup';
import { RFQFTLTripsTable } from '../../components/RFQFTLTripsTable';
import ActionLoader from '../ActionLoader/index';
import ResponsiveTable from 'Components/ResponsiveTable';
import CourierLineItems from 'Components/CourierLineItemsTable';
import AcceptanceOfCeilingPrice from '../Acceptance/AcceptanceOfCeilingPrice';
import { FaTruck } from "react-icons/fa";

// import ConfirmationRemarksPopup from 'Components/ConfirmationRemarksPopup';
import { getUser } from 'Utils/storage';
import { StickyContainer, Sticky } from 'react-sticky';
import PostBidFields from '../PostBidFields/index';
import Input from 'Components/Input'
import Timer from 'Components/Timer';
import Checkbox from 'Components/Checkbox';

import { CHALLENGE_PRICE_SENT, CHALLENGE_PRICE_REJECTED, PRODUCT_TYPE, IS_RIL_RETAIL, IS_CP_TYPE_RFQ, COUNTER_ACCEPT, COST_TYPE, STATIC_DATA, Courier_data, ZONE_LIST, ACC, HIKAL, COUNTER_REJECT, CARGIL, ROQUETTE, CHALLENGE_PRICE_ACCEPTED, TK11STATUS , AWL_AND_CPL, STAR_CEMENT, DEEPAK_PHENOLICS, ABFRL, GALAXY_SURFACE, BEAM, POLYCAB, ADANI, ARDEX, GREEN_PLY} from 'Constants/commonConstants';
import { getCompanyName } from 'Utils/storage';

import { ReactComponent as SEOIcon } from 'Icons/seo.svg'
import { ReactComponent as AcceptIcon } from 'Icons/checked.svg'
import { ReactComponent as RejectIcon } from 'Icons/reject.svg'
import { ReactComponent as CloseIcon } from 'Icons/close.svg';

import Overlay from 'Components/Overlay/index';
import Heading from 'Components/Heading';
import Dropdown from "Components/Dropdown";
import HandlingCharges from "Components/LineItemsTable/handlingCharges";
import WithDrawBid from "Components/WithDrawBid/withdrawbid";
import DisposalProductLineItem from './disposalProductLineItems';
import { ProductAllocation } from './productAllocation';
import Select from 'react-select';
import Moment from 'moment';
import { isCoromandel, isDesmet, isSapDPL, isVishaka } from 'Utils/index';
import ModalT1 from 'Components/Common/Modal/ModalT1';
import ModalCardT3 from 'Components/EXIMCargoTracking/ModalCardT3';
import MaterialDetailsTable from 'Pages/SupplierOrTransportationRequestsDashboard/MaterialDetailsTable';
import { ButtonT11 } from 'Components/Common/Button/index';
import { setItemToSessionStorage } from 'Utils/sessionStorage';
import ModalCardT4 from 'Components/Common/Modal/ModalCardT4';
import { DOWNLOAD_UPLOADED_FILE, GET_PROVIDER_MATERIAL_PACKING_DETAILS } from 'Constants/actionConstants';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom'
import { Spacer } from 'Components/Common/Spacer/index';
import CurrencyConversionDetails from './currencyConversionDetails';
import { getLegLabel } from 'Utils/index';
import { getItemFromLocal, setItemToLocal } from 'Utils/localStorage';
import { VehiclePlaceSceduleTable } from './VehiclePlaceSceduleTable';

 class LineItemsTable extends Component {

   constructor(props) {
      super(props);
      this.state = {
         currentIndex: -1,
         openPopup: false,
         loiAcceptRejectTrip: null,
         isLoiAcceptPopupShown: false,
         isLoiRejectPopupShown: false,
         // hideChallengePriceApprovals: [],
         selectedSubmitButtons: [],
         acceptOrRejectLoiList: [],
         showCharges: false,
         leg: [],
         isChargeEdit: false,
         isChecked: false,
         isTable: false,
         Courier_data: {...Courier_data},
         liners: [],
         additionalLineItems: [],
         isModalPopupOpen:false,
         providerMaterialPackingDetailsLink:'',
         cp_vehicle_details: [],
         legLiners: {},
         // additionalLineItems: []
      }
   }


   saveListOfObjects = (data, typeToAddRemoveUpdate, type) => {
      const { rfq } = this.props;
      if (type === "loi") {
         const { acceptOrRejectLoiList, isChecked } = this.state;
         if (typeToAddRemoveUpdate) {
            acceptOrRejectLoiList.push(data);
         }
         else {
            for (let i = 0; i < acceptOrRejectLoiList.length; i++) {
               if (acceptOrRejectLoiList[i].trip_id === data.trip_id && ((HIKAL.includes(rfq.companyId) || [15,16,31].includes(rfq.type) || (rfq.shippingType !== 1 && [13,14].includes(rfq.type))) ? acceptOrRejectLoiList[i].linerId === data.linerId : true)) {
                  acceptOrRejectLoiList.splice(i, 1);
               }
            }
         }
         this.setState({
            acceptOrRejectLoiList,
         })

         this.setState({
            isChecked: (this.props.lineItems.filter(obj => obj.isLoiSent).length === acceptOrRejectLoiList.length)
         });
      }
      else {
         const { selectedSubmitButtons } = this.state;
         if (typeToAddRemoveUpdate === 2 || typeToAddRemoveUpdate === 3) {
            for (let i = 0; i < selectedSubmitButtons.length; i++) {
               if (selectedSubmitButtons[i].trip_id === data.trip_id) {
                  selectedSubmitButtons.splice(i, 1);
               }
            }
         }
         else {
            if (selectedSubmitButtons.length === 0) {
               selectedSubmitButtons.push(data);
            }
            else {
               let flag = true;
               for (let i = 0; i < selectedSubmitButtons.length; i++) {
                  if (selectedSubmitButtons[i].trip_id === data.trip_id) {
                     flag = false;
                     let data1 = selectedSubmitButtons[i];
                     data1.price = data.price;
                     data1.transporterVol = data.transporterVol;
                     data1.tat = data.tat;
                  }
               }
               if (flag) {
                  selectedSubmitButtons.push(data);
               }
            }
         }
      }

   }

   postBidList = (type) => {
      let { selectedSubmitButtons, acceptOrRejectLoiList } = this.state;
      const { rfq, lineItems } = this.props;
      if (!JSON.parse(localStorage.getItem("termsAndConditionsAccepted"))){
         alert('Please Accept Terms And Conditions');
         return;
      }
      if(rfq && rfq.companyId === "737" && type === 3){
         if(selectedSubmitButtons.length === 0 && (rfq && !rfq.rfqDetails.acceptPartialSolution)) {
            (lineItems || []).forEach(trip => {
               if(trip.isLoiSent && !trip.isAccept) {
                  selectedSubmitButtons.push({
                     trip_id: trip.id,
                     is_loi_with_cp_sent: trip.isLoiWithCPSent,
                     challenge_price: trip.challengePrice,
                     l1AcceptMandatory: trip.l1AcceptMandatory,
                     linerId: trip.linerId
                  })
               }
            });
            acceptOrRejectLoiList = selectedSubmitButtons;
         }
         if(acceptOrRejectLoiList.length > 0) {
            this.setState({
               isLoiRejectPopupShown: true,
               selectedSubmitButtons,
               acceptOrRejectLoiList
            });
         } 
      } else {

      let listOfObjects = selectedSubmitButtons;

      if (!JSON.parse(localStorage.getItem("termsAndConditionsAccepted"))){
         alert('Please Accept Terms And Conditions');
         return;
      }
      // if(type === 1 && rfq && rfq.companyId === "737" && rfq.rfqTypeLtc === "LTC" && !rfq.rfqDetails.acceptPartialSolution && !((selectedSubmitButtons.length == lineItems.length) || (((lineItems || []).filter(lineItem => lineItem.price).length) > 0))) {
      //    this.props.errorMessage('Please enter the price for all the line Items');
      //    return;
      // }

      if (type === 2 || type === 3) {
         listOfObjects = acceptOrRejectLoiList;
         if(listOfObjects.length === 0 && (rfq && !rfq.rfqDetails.acceptPartialSolution && ['737', ...STAR_CEMENT].includes(rfq.companyId))) {
            (lineItems || []).forEach(trip => {
               if(trip.isLoiSent && !trip.isAccept) {
                  listOfObjects.push({
                     trip_id: trip.id,
                     is_loi_with_cp_sent: trip.isLoiWithCPSent,
                     challenge_price: trip.challengePrice,
                     l1AcceptMandatory: trip.l1AcceptMandatory,
                     linerId: trip.linerId
                  })
               }
            })
         }
      }
      else {
         for (let i = 0; i < selectedSubmitButtons.length; i++) {
            if (selectedSubmitButtons[i].price === '' || selectedSubmitButtons[i].price === 0) {
               alert("Please enter price");
               return;
            }
         }
      }
      if(type === 3) {
         listOfObjects = (listOfObjects || []).filter(list => !list.l1AcceptMandatory);
      }
      if(HIKAL.includes(rfq.companyId) || [15,16,31].includes(rfq.type) || (rfq.shippingType !== 1 && [13,14].includes(rfq.type))) {
         listOfObjects = (listOfObjects || []).map(list =>{ return {...list, liner_id: list.linerId }});
      }
      this.props.postBidAll(type, listOfObjects);
      this.setState({ selectedSubmitButtons: [], acceptOrRejectLoiList: [], isChecked: false });
   }
   }

   rejectAllLoi = () => {
      const { selectedSubmitButtons, acceptOrRejectLoiList } = this.state;
      const { rfq, lineItems } = this.props;

      let listOfObjects = selectedSubmitButtons;

      if (!JSON.parse(localStorage.getItem("termsAndConditionsAccepted"))){
         alert('Please Accept Terms And Conditions');
         return;
      }
      let type=3;
      if (type === 2 || type === 3) {
         listOfObjects = acceptOrRejectLoiList;
         if(listOfObjects.length === 0 && (rfq && !rfq.rfqDetails.acceptPartialSolution && rfq.companyId === '737')) {
            (lineItems || []).forEach(trip => {
               if(trip.isLoiSent && !trip.isAccept) {
                  listOfObjects.push({
                     trip_id: trip.id,
                     is_loi_with_cp_sent: trip.isLoiWithCPSent,
                     challenge_price: trip.challengePrice,
                     l1AcceptMandatory: trip.l1AcceptMandatory,
                     linerId: trip.linerId
                  })
               }
            })
         }
      }
      else {
         for (let i = 0; i < selectedSubmitButtons.length; i++) {
            if (selectedSubmitButtons[i].price === '' || selectedSubmitButtons[i].price === 0) {
               alert("Please enter price");
               return;
            }
         }
      }
      this.hideRejectPopup();
      if(HIKAL.includes(this.props.rfq.companyId) || [15,16,31].includes(rfq.type) || (rfq.shippingType !== 1 && [13,14].includes(this.props.rfq.type))) {
         listOfObjects = (listOfObjects || []).map(list =>{ return {...list, liner_id: list.linerId }});
      }
      this.props.postBidAll(type, listOfObjects, this.state.loiRejectionReason);
      this.setState({ selectedSubmitButtons: [], acceptOrRejectLoiList: [], isChecked: false , loiRejectionReason:""});
      
   }

   showAcceptPopup = (trip) => {
      if (!JSON.parse(localStorage.getItem("termsAndConditionsAccepted"))){
         alert('Please Accept Terms And Conditions');
         return;
      }
      this.setState({
         isLoiAcceptPopupShown: true,
         loiAcceptRejectTrip: trip
      });
   }

   acceptClicked = (e, trip) => {
      const data = {
         trip_id: trip.id,
         is_loi_with_cp_sent: trip.isLoiWithCPSent,
         challenge_price: trip.challengePrice,
         l1AcceptMandatory: trip.l1AcceptMandatory,
         linerId: trip.linerId
      }
      this.saveListOfObjects(data, e.target.checked, "loi");

   }

   selectAllLoi = (e, lineItem) => {
      const { acceptOrRejectLoiList } = this.state;
      const { rfq } = this.props;
      if (e.target.checked) {
         lineItem.map((trip) => {
            if (trip.isLoiSent && !trip.isAccept && !acceptOrRejectLoiList.find((loi) => loi.trip_id === trip.id && ((HIKAL.includes(rfq.companyId) || [15,16,31].includes(rfq.type) || (rfq.shippingType !== 1 && [13,14].includes(rfq.type))) ? loi.linerId === trip.linerId : true))) {
               this.acceptClicked(e, trip);
            }
         });
      } else {
         this.setState({ acceptOrRejectLoiList: [] });
      }
      this.setState({
         isChecked: e.target.checked,
      })
   }

   hideAcceptPopup = (trip) => {
      this.setState({
         isLoiAcceptPopupShown: false,
         loiAcceptRejectTrip: trip
      });
   }
   showRejectPopup = (trip) => {
      if (!JSON.parse(localStorage.getItem("termsAndConditionsAccepted"))){
         alert('Please Accept Terms And Conditions');
         return;
      }
      this.setState({
         isLoiRejectPopupShown: true,
         loiAcceptRejectTrip: trip,
         counterPrice: trip.boxPrice || trip.counterPrice,
         tripCounter: true
      });
   }
   hideRejectPopup = (trip) => {
      this.setState({
         isLoiRejectPopupShown: false,
         loiRejectionReason:"",
         counterPrice: '',
         tripCounter: false
      });
   }
   acceptLoi = () => {
      const data = {
         trip_id: this.state.loiAcceptRejectTrip.id,
         linerId: this.state.loiAcceptRejectTrip.linerId || undefined
      }
      this.props.acceptLoi(this.state.loiAcceptRejectTrip);
      this.hideAcceptPopup();
      this.saveListOfObjects(data, false, "loi");

   }
   rejectLoi = () => {
      const { rfq, postChallengePrice } = this.props;
      const { loiAcceptRejectTrip, counterPrice, tripCounter } = this.state;
      const data = {
         trip_id: this.state.loiAcceptRejectTrip.id,
         linerId: this.state.loiAcceptRejectTrip.linerId || undefined
      }
      this.props.rejectLoi(this.state.loiAcceptRejectTrip, this.state.loiRejectionReason);
      if( rfq && rfq.companyId === "737" && tripCounter && counterPrice && loiAcceptRejectTrip['counterPrice' || 'boxPrice'] !== counterPrice) {
         postChallengePrice(loiAcceptRejectTrip.id, {
            transporterVol: loiAcceptRejectTrip.transporterVol,
            tat: loiAcceptRejectTrip.tat && {
               unit: ((loiAcceptRejectTrip.tat || {}).tatUnit || {}).tatUnit || '',
               value: (loiAcceptRejectTrip.tat || {}).tatValue || '',
               name: ((loiAcceptRejectTrip.tat || {}).tatUnit || {}).tatUnitName
            } || {
               unit: loiAcceptRejectTrip.biddingDetails.tatUnit,
               value: loiAcceptRejectTrip.biddingDetails.tatValue,
               name: loiAcceptRejectTrip.biddingDetails.tatUnitName
            },
            counter_price: Number(counterPrice),
            is_counter: true,
            type: 1
         }); 
      }
      this.hideRejectPopup();
      this.saveListOfObjects(data, false, "loi");
     
      if(rfq.companyId=="737"){
         this.setState({
            loiRejectionReason:""
         })
      }

   }
   setCurrentIndex(index) {
      this.setState({ currentIndex: index }, () => {
         if (this.state.currentIndex > -1) {
            this.props.removeOverFlowHidden();
         } else {
            this.props.setOverFlowHidden();
            this.setState({ openPopup: false });
         }
      });
   }
   handleChallengePrice = (type, item) => {
      if (type === 'accept') {
         const { cp_vehicle_details = [] } = this.state;
         if(isDesmet(item.companyId)) {
            if(item.challengePrice !== this.getTotalForMultipleVehicle(item)) {
               alert('Total Price should be equal to challenge price');
               return;
            }
         }
         this.props.postChallengePrice(item.id, {
            price: Number(item.challengePrice),
            price_usd: Number(item.challengePriceUSD),
            price_secondary: Number(item.challengePriceSecondary),
            type: 0,
            tat: {
               unit: item.tat.tatUnit.unit,
               value: Number(item.tat.tatValue),
               name: item.tat.tatUnit.tatUnitName
            },
            ...(isDesmet(item.companyId) ? {
               transporter_vehicle: cp_vehicle_details[item.id] || item.transporter_vehicle
           }: {})
         });
         this.props.acceptRejectCP(item.id, true);
         this.setState({
            cp_vehicle_details: []
         });
      } else {
         this.props.acceptRejectCP(item.id, false);
      }
   }
   getHeaderForBidStarted(count, lineItems) {
      const trip = ((lineItems || [])[0] || {});
      const { rfq } = this.props;
      // const isQbrShow = ['999', '872'].includes(trip.companyId) ? trip.qbrShowRate : true;
      const isQbrShow = true;
      return <div className="flex flex-between flex-middle pl-25 pr-25">
          <div className="fBold fs-16 header-dark-color wt-250">Location</div>
         {isQbrShow && !trip.hideCeilingPrice && <div className="fBold fs-16 header-dark-color wt-200 pl-15">Ceiling Price / TAT</div>}
         <div className="fBold fs-16 header-dark-color flex-1">My Bid 
         {(this.props.rfq && !this.props.rfq.rfqDetails.acceptPartialSolution) && 
         <>
            {this.props.totalValueVisibilityOnProvider && trip.sum_of_product_price && <div className="fBold fs-12 theme-color">Total Value {this.props.visibilityOfLotRankingForProvider && trip.sum_order_text && `(${trip.sum_order_text})`} :₹{trip.sum_of_product_price.toFixed(1).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
            {this.props.totalValueVisibilityOnProvider && trip.sum_price_volume_mt && <div className="fBold fs-12 theme-color">Total Value (MT) {this.props.visibilityOfLotRankingForProvider && trip.sum_order_text && `(${trip.sum_order_text})`} :₹{trip.sum_price_volume_mt.toFixed(1).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
            {this.props.totalValueVisibilityOfL1OnProvider && trip.sum_order_text !== 'L1' && trip.sum_lowest_price && <div className="fBold fs-12 success-color">Total Value(L1):₹{trip.sum_lowest_price.toFixed(1).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
            {this.props.totalValueVisibilityOfL1OnProvider && trip.sum_order_text !== 'L1' && trip.lowest_price_volume_mt && <div className="fBold fs-12 success-color">Total Value(MT) (L1):₹{trip.lowest_price_volume_mt.toFixed(1).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
         </>
         }</div>
         {trip && !trip.isWithdrawBid && this.props.rfq.isEnableWithdrawBid && (!this.props.rfq.rfqDetails.acceptPartialSolution || this.props.rfq.rfqTypeLtc) && ((this.props.maxCountToWithdrawBid && trip.withdraw_bid_count) ? (trip.withdraw_bid_count < this.props.maxCountToWithdrawBid) : true) &&<div class="fBold theme-color tCenter fs-14 pt-5 curP pr t-8 pr-20"  onClick={(e) => this.withdrawAllBid(e)}> Withdraw Bid</div>}
         {((rfq && ['737'].includes(rfq.companyId) && !rfq.rfqDetails.acceptPartialSolution) ? ((trip.isAccessBidWithdrawn && trip.isWithdrawBid) ? (count === lineItems.length) : (((((lineItems || []).filter(lineItem => lineItem.price).length) > 0) || (count === lineItems.length)) && count > 0)) : (count > 0)) && !isDesmet(rfq.companyId) && <div class="fBold theme-color tCenter fs-14 pt-5 curP pr t-8" onClick={(e) => { e.stopPropagation(); this.postBidList(1) }}> Submit All({count})</div>}
      </div>
   }
   openLineItemOverlay(lineItem) {
      this.setState({ currentLineItem: lineItem }, () => {
         this.setState({ openLineItem: true });
      });
   }

   handlePriceUpdate = (price, item, nextApiData, tat, unit) => {
      this.setState({ leg: nextApiData });
      if (parseFloat(price) != parseFloat(item.price) || parseFloat(tat) != parseFloat(item.tat.tatValue)|| item.tat.tatUnit && parseFloat(tat.unit) != parseFloat(item.tat.tatUnit.tatUnit) ) {
         this.setState({ handlingPriceInvoked: price, nextApiData, isTripPriceUpdated: (parseFloat(price) != parseFloat(item.price)) });
         this.isPriceInvoked(true);
      }
   }

   handlePriceUpdateStore = (price, item, nextApiData, tat) => {
      let data = {
         price,
         tat: {
            "unit": 1,
            "value": 1,
            "name": "Days"
         },
         // ...data,
         isTripPriceUpdated: parseFloat(price) != parseFloat(item.price)
      }
      this.props.bulkUpdateDataStore(item.id, data, this.updateStoreHandlingCharge(nextApiData));
   }

   isPriceInvoked = (val) => {
      this.setState({
         isPriceOptimized: val
      });
   }

   changeTransVehicle = (e, linItem, index) => {
      const { name, value } = e.currentTarget;
      const { cp_vehicle_details = [] } = this.state;
      if(cp_vehicle_details[linItem.id]) {
         cp_vehicle_details[linItem.id][index][name] = value && +value || value;
      } else {
         cp_vehicle_details[linItem.id] = linItem.transporter_vehicle;
         cp_vehicle_details[linItem.id][index][name] = value && +value || value
      }
      cp_vehicle_details[linItem.id][index]['price'] = (+cp_vehicle_details[linItem.id][index]['number_of_vehicle'] * +cp_vehicle_details[linItem.id][index]['price_per_vehicle'])
      this.setState({
         cp_vehicle_details
      });
   }

   getInputValue = (field, value, id, index) => {
      let fValue = value;
      const { cp_vehicle_details = [] } = this.state;
      if(cp_vehicle_details[id]) {
         fValue = cp_vehicle_details[id][index][field]
      }
      return fValue;
   }

   getTotalForMultipleVehicle = (lineItem) => {
      let data = lineItem.transporter_vehicle;
      const { cp_vehicle_details = [] } = this.state;
      if(cp_vehicle_details[lineItem.id]) {
         data = cp_vehicle_details[lineItem.id];
      }
      return (data || []).reduce((sum, el) => sum += Number(el.price || 0), 0);
   }

    getAdaniEximLineItemWiseBidRemarks(lineItem, isAdani) {
       if (isAdani && [13, 14, 15, 16, 31].includes(lineItem.rfqType)) {
          if (lineItem.legs && Object.keys(lineItem.legs).length > 0 && Array.isArray(lineItem.legs) && lineItem.legs.length > 0) {
             return lineItem.legs[0].provider_bid_remarks || '';
          }
       }
       return '';
    }

//    getChallengePriceTimeValid = (lineItem) => {
//       const { systemTime } = this.props;
//       let cpTimeValid = false;
//       if (lineItem.CPAcceptValidFrom && lineItem.CPAcceptValidTo) {
//           if (lineItem.CPAcceptValidTo < systemTime) {
//               cpTimeValid = true;
//           }
//       }
  
//       return cpTimeValid;
//   }
   getObdsDetailsData=(lineItem)=>{
      return <table width="100%">
               <tr>
                  <td width="150"><div className="section-sub-header-color fs-14 op-79">OutBound Delivery</div></td>
                  <td width="100"><div className="section-sub-header-color fs-14 op-79">Plant Code</div></td>
                  {/* <td width="100"><div className="section-sub-header-color fs-14 op-79">Route Code</div></td> */}
                  <td width="150"><div className="section-sub-header-color fs-14 op-79">Material Name</div></td> 
                  {(lineItem.isBags === 1) ?  <td width="50"><div className="section-sub-header-color fs-14 op-79">Bags</div></td>: <td width="50"><div className="section-sub-header-color fs-14 op-79">Bulk</div></td>} 
                  <td width="200"><div className="section-sub-header-color fs-14 op-79">Ship To Name</div></td>
                  <td width="50"><div className="section-sub-header-color fs-14 op-79">Qty</div></td>
                  <td width="100"><div className="section-sub-header-color fs-14 op-79">Tzone</div></td>
                  <td width="100"><div className="section-sub-header-color fs-14 op-79">Dist. Code</div></td>
                  <td width="100"><div className="section-sub-header-color fs-14 op-79">Dist. Name</div></td>
                  <td width="100"><div className="section-sub-header-color fs-14 op-79">Region Name</div></td>
                  <td width="100"><div className="section-sub-header-color fs-14 op-79">Taluka Name</div></td>
                  <td width="50"><div className="section-sub-header-color fs-14 op-79">Dist.Channel</div></td>
               </tr>
               <tr>
                  <td><div className="fBold fs-12 theme-color">{lineItem.outboundDelivery}</div></td>
                  <td><div className="fBold fs-12 theme-color"> {lineItem.plantCodeone}</div></td>
                  {/* <td><div className="fBold fs-12">{lineItem.obdsroutecode}</div></td> */}
                  <td><div className="fBold fs-12 theme-color">{lineItem.materialName}</div></td>
                  {/* <td><div className="fBold fs-12">{lineItem.obdsroutecode}</div></td> */}
                  { (lineItem.isBags === 1) ? <td> <div className="fBold fs-12 theme-color">{lineItem.bags}</div></td> : <td> <div className="fBold fs-12 theme-color">{lineItem.isBulk}</div></td>}
                  <td><div className="fBold fs-12 theme-color">{lineItem.shipToName}</div ></td>
                  <td><div className="fBold fs-12 theme-color"> {lineItem.qty} ({lineItem.celingPriceUnit})</div></td>
                  <td><div className="fBold fs-12 theme-color"> {lineItem.lzone} </div></td>
                  <td><div className="fBold fs-12 theme-color">{lineItem.distCode}</div></td>
                  <td><div className="fBold fs-12 theme-color">{lineItem.distName}</div></td>
                  <td><div className="fBold fs-12 theme-color">{lineItem.regionName}</div></td>
                  <td><div className="fBold fs-12 theme-color">{lineItem.talukaName}</div></td>
                  <td><div className="fBold fs-12 theme-color">{lineItem.distChannel}</div></td>
               </tr>
            </table>
   }

   withdrawAllBid=(e)=>{
      e.stopPropagation();
      this.setState({
         isShowWithDraw: true
      })
   }

   shouldRenderPickupDropPoint = (lineItem) => {
      const isArdex = ARDEX.includes(lineItem.companyId);
      let enable = false;
      if(lineItem.noOfPickups > 1 || lineItem.noOfDrops > 1){
         enable = true;
      } else if(isArdex && (lineItem.noOfPickups > 0 || lineItem.noOfDrops > 0)){
         enable = true;
      }
      return enable;
   }

    postBidPriceDetails = (lineItem) => {
      const isGrnPly = GREEN_PLY.includes(lineItem.companyId);
      if (isGrnPly){
         return (lineItem.price)
      }
      return (lineItem.boxPrice || lineItem.price)
   }

   getBodyForBidStarted(lineItem, index, categories, vehicleTypesList, isRilCPForm, LinersList) {
      const rfq = this.props.rfq;
      const isACC = (rfq.companyId === ACC)
      const cities = lineItem.stops.map((stop) => stop.city);
		const { postBid, tripBids, fetchBids, systemTime, postBidAll, lineItems, currencyDetails, currencyTypes, isAccessBidWithdrawn, vendorWithDrawBid, seaAndAirLines, allowTransporterToAddCostHeadDuringBidding, getPlantWiseCostHeads } = this.props;
      const { selectedSubmitButtons, acceptOrRejectLoiList, handlingPriceInvoked, isPriceOptimized, leg, isShowWithDraw } = this.state;
      // var secKmRun = lineItems.map(e => (secKmRun = e.secKmRun))
      const cType = (currencyTypes || []).find(el => el.currency_type === lineItem.legCostValue) || {};
      // const isQbrShow = ['999', '872'].includes(lineItem.companyId) ? lineItem.qbrShowRate : true;
      const isQbrShow = true;
      const isAdani = ['999', '872'].includes(lineItem.companyId);
      const isGrnPly = GREEN_PLY.includes(lineItem.companyId);
      const legName = ((rfq.type == 15 && getLegLabel(lineItem, this.props.lineItems, index)) || '');

      return <Fragment>
         <div className={classNames("border-top-light pt-10 pb-10 bg-hover-light pl-25 pr-25", {
            'selected': this.state.currentIndex === index
         })} key={index}>
         { rfq.isShowObdsDetails &&
            this.getObdsDetailsData(lineItem)
         }
         <div className="flex fSemibold flex-between flex-middle">
         <div className="wt-250">
            <div className="fs-14 section-sub-header-color fs-14 lh-15p fRegular break-word">
               {(HIKAL.includes(lineItem.companyId) || [15,16,31].includes(lineItem.rfqType) || (rfq.shippingType !== 1 && [13,14].includes(lineItem.rfqType))) && <div className='theme-color fBold fs-16'>{isAdani ? legName : `Liner ${index + 1}`}</div>}
               {lineItem.container_type_name && <div className='theme-color fBold fs-16'>{lineItem.container_type_name}</div>}
               <span key={index}>{GALAXY_SURFACE.includes(lineItem.companyId) ?
                  <>
                  {
                     (lineItem.ftlStops || []).map((stop, index)=> {
                        return (
                           <span>{(stop.location && (stop.location.split(',') || [])[0] || stop.city)}{(((lineItem.ftlStops || []).length - 1) !== index) ? <Back className="wt-10 ml-5 mr-5 mt-5 rotate-180deg" /> : ''}</span>
                        )
                     })
                  }
              </>:
               <>{!rfq.enableRouteDescription && lineItem.from}{lineItem.stops && lineItem.stops.length > 0 && <>{this.getStopDetails(lineItem.stops, 0)}</>}
               {lineItem.to && 
               <Fragment>
                  {!rfq.enableRouteDescription &&<Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" /> }
                  {lineItem.to}{lineItem.stops && lineItem.stops.length > 1 && <>{this.getStopDetails(lineItem.stops, 1)}</>}
               </Fragment>}
               </>}
               </span>
               <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  {lineItem.multi_mode_leg_trip[0] && <span>{lineItem.multi_mode_leg_trip[0].leg_type_name}</span>}
                  {lineItem.rfqType === 6 && <span>{lineItem.providerName === 'Transporter' ? 'Transportation Charges' : `${lineItem.providerName} charges`}</span>}
                  {lineItem.rfqType === 6 && lineItem.providerName !== 'Transporter' && lineItem.noOfManPower && <span>{`Man Power: ${lineItem.noOfManPower}`}</span>}
               </div>
               {(CARGIL.includes(rfq.companyId) && lineItem.consigneeTypeName) && <div className="section-sub-header-color fs-12 op-79 lh-15p pt-5">
                  <span>Consignee Type : </span><span className='theme-color'>{lineItem.consigneeTypeName}</span>
               </div> || null}
               {(lineItem.rfqType === 1 && isAdani) && <div><span className='fBold theme-color'>Contract Type: </span><span>{lineItem.contract_type_name}</span></div>}
               {(lineItem.rfqType === 12 && isAdani) && <div className={'fs-12'}><span className='fBold theme-color'>Border Location: </span><span className={'error-color ml-3 fBold'}>{(lineItem.borderLocation || {}).location}</span></div>}

               {isDesmet(rfq.companyId) && ((lineItem.consigners || [])[0] || {}).company_name && <div className='fs-12 mt-3'><span className='fBold theme-color'>Consignor: </span><span>{`${((lineItem.consigners || [])[0] || {}).company_name}, ${((lineItem.consigners || [])[0] || {}).address}`}</span></div>}
               {isDesmet(rfq.companyId) && ((lineItem.consignees || [])[0] || {}).company_name && <div className='fs-12 mt-3'><span className='fBold theme-color'>Consignee: </span><span>{`${((lineItem.consignees || [])[0] || {}).company_name}, ${((lineItem.consignees || [])[0] || {}).address}`}</span></div>}
            </div>
            <div className="section-sub-header-color fs-12 lh-15p pt-5">
               {lineItem.biddingDetails.businessVolumeValue ? <Fragment>{(rfq.type === 3 && isAdani ? 'Business Volume(MT): ' : (CARGIL.includes(rfq.companyId) ? 'Business Volume: ' : ''))}{lineItem.biddingDetails.businessVolumeValue} {lineItem.biddingDetails.businessVolumeUnitName} </Fragment> : null}
               {(CARGIL.includes(rfq.companyId) && (lineItem.biddingDetails || {}).businessVolumeValue) && <br/> || ''}
               {this.shouldRenderPickupDropPoint(lineItem) ? <div><span className="vehicle-pickup-drop-span">{lineItem.noOfPickups} {'Pickups |'} {lineItem.noOfDrops} {'Drops'}</span>
                  <a data-tip data-for={`scrollContent-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">i</span> </a>
                  <ReactTooltip
                     id={`scrollContent-${index}`}
                     type="light"
                     effect="solid"
                     place="right"
                     className="tooltip-trip-shadow"
                     delayHide={100}
                  >
                     <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                        <section className="flex mt-25 flex-column">
                           <RFQFTLTripsTable lineItem={lineItem} />
                        </section>
                     </div>
                  </ReactTooltip>
               </div>
                  :
                  <>{lineItem.rfqType !== 6 && <span>. {lineItem.noOfPickups} {'Pickup |'} {lineItem.noOfDrops} {'Drop'}</span>}</>}
            </div>
            {rfq.type !== 3 && lineItem.vehicleTypeName && <div className="section-sub-header-color fs-12 op-79 lh-15p ">
               {lineItem.vehicleTypeName}, {lineItem.vehicleBodyTypeName}
            </div>}
            {(lineItem.placementTime) && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
               Placement Time: <span className="fBold">{lineItem.placementTimeFormatted}</span>
            </div>}
            {POLYCAB.includes(lineItem.companyId) && lineItem.shipment_id && <div className="section-sub-header-color fs-12 op-79 lh-15p ">
            Shipment ID:  <span className="fBold">{lineItem.shipment_id} {`(${lineItem.shipment_status})`}</span>
            </div>}
            {rfq.type === 3 && isAdani && (rfq.rfqDetails || {}).secondaryContractType === 2 && <div className="section-sub-header-color fs-14 op-79 lh-15p ">
               Slab (MT):  <span className="fBold">{lineItem.fromRange} - {lineItem.toRange}</span>
            </div>}
            {rfq && (rfq.rfqDetails || {}).ftlContractType === 2 && <div className="section-sub-header-color fs-14 op-79 lh-15p ">
               Slab:  <span className="fBold">{lineItem.fromRange} - {lineItem.toRange}</span>
            </div>}
            {lineItem.slab_name && <div className='mt-5 fs-14'>
               <span className='fBold theme-color'>{`Slab${lineItem.pricingBasisName ? `(${lineItem.pricingBasisName})` : ''}: `}</span> <span>{lineItem.slab_name}</span>
            </div> || ''}
            {rfq.type === 3 && isAdani && (rfq.rfqDetails || {}).secondaryContractType === 1 &&
               <>
                  <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                     Carrying Capacity(MT):  <span className="fBold">{lineItem.carryingCapacity}</span>
                  </div>
                  <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                     Fixed km/Month:  <span className="fBold">{lineItem.fixedKmPerMonth}</span>
                  </div>
                  <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                     Extra cost/km :  <span className="fBold">{lineItem.extraCostPerKm && formatToINR(lineItem.extraCostPerKm)}</span>
                  </div>
               </>
            }
            {rfq.type === 8 &&
               <>
                  <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                     Quantity:  <span className="fBold">{lineItem.total_estimated_qty}</span>
                  </div>
                  <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                     UOM:  <span className="fBold">{lineItem.uom}</span>
                  </div>
               </>
            }
            {rfq.type === 3 && lineItem.secKmRun && <div className="section-sub-header-color fs-12 op-79 lh-15p ">
               KM Run - {lineItem.secKmRun}
            </div>}
            {rfq.type === 3 && lineItem.secUptoKM && <div className="section-sub-header-color fs-12 op-79 lh-15p ">
               Minimum Km - {lineItem.secUptoKM}
            </div>}
            {
               !isACC && lineItem.distance && lineItem.rfqType !== 6 && 
               <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  {lineItem.distance} {lineItem.distanceUOM}
               </div>
            }
            { 
               lineItem.vehicleRemarks &&
               <span className="fs-12 op-79 lh-15p theme-color">{lineItem.vehicleRemarks}</span>
            }
            {isVishaka(rfq.companyId) && (lineItem.biddingDetails.cargoQuantity || {}) &&
               <span className="section-sub-header-color fs-12 mt-5 mb-5 op-79"><b>Cargo Weight:</b> {lineItem?.biddingDetails?.cargoQuantity} {rfq?.packing_type_name}</span>
            }
            {
               categories &&
               <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  <b className="op-full fBold header-dark-color">Product Type:</b> {lineItem.productCategoryTypeName}
               </div>
            }
            <br/>
            {isVishaka(rfq.companyId) &&
               lineItem.vehicleRemarks &&
               <span className="fs-12 op-79 lh-15p theme-color">{lineItem.vehicleRemarks}</span>
            }
            {isVishaka(rfq.companyId) && lineItem.vehicle_placement_schedule && 
            <div><span className="vehicle-pickup-drop-span">
            <FaTruck className="theme-color fs-18" />
            </span>
            <a data-tip data-for={`scrollContent-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">i</span> </a>
            <ReactTooltip
                     id={`scrollContent-${index}`}
                     type="light"
                     effect="solid"
                     place="right"
                     className="tooltip-trip-shadow"
                     delayHide={100}
                  >
                     <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                        <section className="flex mt-25 flex-column">
                         <VehiclePlaceSceduleTable lineItem={lineItem} />
                        </section>
                     </div>
                  </ReactTooltip>
            </div>
            }
            {(lineItem.tripContractTenureFrom || lineItem.contractTenureFrom) && <span className="fs-12 op-79 lh-15p pb-5 header-dark-color fBold">{'Contract Tenure:'}  {lineItem.tripContractTenureFrom ? Moment(lineItem.tripContractTenureFrom).format('Do MMM, YYYY') : Moment(lineItem.contractTenureFrom).format('Do MMM, YYYY')} </span> } 
            {(lineItem.tripContractTenureTo || lineItem.contractTenureTo) &&<span className="fs-12 op-79 lh-15p pb-5 header-dark-color">To  <span className='fBold'>{lineItem.tripContractTenureTo ? Moment(lineItem.tripContractTenureTo).format('Do MMM, YYYY') : Moment(lineItem.contractTenureTo).format('Do MMM, YYYY')} </span></span>}
               
            {/* { 
               lineItem.vehicleRemarks &&
               <span className="section-sub-header-color fs-12 op-79 lh-15p theme-color">{lineItem.vehicleRemarks}</span>
            } */}

                  {(isDesmet(lineItem.companyId) && (lineItem.consignor_details || {}).consignor_name) && <Fragment>
                     <div className='flex flex-middle gap-10'>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p">Consignor Name :</div>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p">{(lineItem.consignor_details || {}).consignor_name}</div>
                     </div>
                  </Fragment>}

            <div className="section-sub-header-color fs-12 op-79 lh-15p ">
               {
                  !!((lineItem.challengePrice !== lineItem.price) &&
                     lineItem.cpState !== CHALLENGE_PRICE_SENT &&
                     lineItem.tripBidEnd && !lineItem.isLoiSent &&
                     !(lineItem.isAccept === true) &&
                     !(lineItem.isAccept === false) &&
                     lineItem.tripBidEnd && new Date(lineItem.tripBidEnd).getTime() > 0 &&
                     //new Date().getTime() < new Date(lineItem.tripBidEnd).getTime()) &&
                     systemTime < new Date(lineItem.tripBidEnd).getTime()) &&
                  <Timer from={lineItem.biddingDetails.from} to={lineItem.tripBidEnd} currentTime={systemTime} />
               }
               {
                  lineItem.trip_bidding_end && lineItem.trip_bidding_end >= systemTime &&
                  <Timer from={lineItem.biddingDetails.from} to={lineItem.trip_bidding_end} currentTime={systemTime} />
               }
            </div>
            {
               lineItem.relayEndTime &&
               lineItem.biddingDetails.to &&
               lineItem.relayEndTime >= systemTime &&
               // lineItem.relayEndTime >= new Date().getTime() &&
               // lineItem.biddingDetails.to < new Date().getTime() &&
               ((index > 0 && lineItem.autoBidRelayTime) ? lineItems[index - 1].relayEndTime < systemTime  : true) && 
               lineItem.biddingDetails.to < systemTime &&
               <Timer
                  from={lineItem.biddingDetails.to}
                  to={lineItem.relayEndTime}
                  //currentTime={new Date().getTime()}
                  currentTime={systemTime}
                  isRelayBid={true}
               />
            }
         </div>
         {isQbrShow && !lineItem.hideCeilingPrice && <div className="wt-200 pl-15 section-sub-header-color fs-14 lh-15p flex flex-column">
				{(rfq.type !== 5 && rfq.type !== 6 && ![13,14,15,16,31].includes(rfq.type)) && formatToINR(lineItem.biddingDetails.qbr)}
            {rfq.type === 6 && formatToINR(lineItem.qbr)}
				{(rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) && 
					formatToINR(lineItem.biddingDetails.qbr_inr)
				}<br></br>
				{((rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) && lineItem.priceInBaseCurrency !== 'INR') && <div>{lineItem.priceInBaseCurrencySymbol || ''}
					{lineItem.priceInBaseCurrency !== 'INR' && lineItem.biddingDetails[`qbr_${lineItem.priceInBaseCurrency === 'USD' ? 'usd' : 'secondary'}`]}</div>
				}
            {
               lineItem.biddingDetails.tatValue ?
               <div>
                  / {lineItem.biddingDetails.tatValue} {lineItem.biddingDetails.tatUnitName}
               </div> : ''
            }
				
         </div>}
         <div className="section-sub-header-color fs-14 flex-1 lh-15p pr flex-middle flex">
            <div className={classNames("flex flex-row flex-middle", {
               'wt-270': !(isAdani && rfq.type == 15)
            })}>
               {<span className="br-5 pt-35 pr-10 pl-10 pt-10 pb-10 pr t--7">
                  <PostBidFields
                     saveListOfObjects={this.saveListOfObjects.bind(this)}
                     readOnly={(!isGrnPly && lineItem.lotId) || rfq.type === 2 || (rfq.type === 3 && (isAdani ? rfq.rfqDetails.secondaryContractType !== 2 : true)) || rfq.type === 5 || [13,14,15,16,31].includes(rfq.type) ||
                        // (lineItem.biddingDetails.to < new Date().getTime() && lineItem.relayEndTime < new Date().getTime()) ? true : false
                        (((index > 0 && lineItem.biddingDetails.to < systemTime && lineItem.autoBidRelayTime && lineItems[index - 1].relayEndTime > systemTime) ? true : (lineItem.biddingDetails.to < systemTime && lineItem.relayEndTime < systemTime))) ? true : false
                     }
                     currencyTypes={currencyTypes}
                     lineItem={lineItem}
                     biddingDetails={{
                        price: this.postBidPriceDetails(lineItem),
								price_usd: (rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) ? lineItem.priceUSD : "",
                        price_secondary: (rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) ? lineItem.priceSecondary : "",
                        priceInBaseCurrency: lineItem.priceInBaseCurrency,
                        priceInBaseCurrencySymbol: lineItem.priceInBaseCurrencySymbol,
                        transporterVol: lineItem.transporterVol,
                        allowBusinessVolume: lineItem.allowBusinessVolume,
                        showTat: lineItem.showTat,
                        rfqType: lineItem.rfqType,
                        biddingEnd: (lineItem.biddingDetails.to < systemTime),
                        tat: lineItem.tat || {
                           tatValue: lineItem.biddingDetails.tatValue,
                           tatUnit: {
                              tatUnitName: lineItem.biddingDetails.tatUnitName,
                              tatUnit: lineItem.biddingDetails.tatUnit
                           }
                        }, 
                        containerFreeDay: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? (lineItem.legs &&  Object.keys(lineItem.legs).length > 0 && lineItem.legs && lineItem.legs.length > 0 && lineItem.legs[0].containerFreeDay) : '',
                        exim_inco_terms: isAdani && lineItem.rfqType === 15 ? rfq.eximIncoTerms : undefined,
                        provider_bid_remarks: this.getAdaniEximLineItemWiseBidRemarks(lineItem, isAdani),
                        containerDaysHours: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? (lineItem.legs &&  Object.keys(lineItem.legs).length > 0 && lineItem.legs && lineItem.legs.length > 0 && lineItem.legs[0].containerDaysHours) : '',
                        shippingLineName: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? (lineItem.legs &&  Object.keys(lineItem.legs).length > 0 && lineItem.legs && lineItem.legs.length > 0 && lineItem.legs[0].shippingLineName) : '',
                        containerFree: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? (lineItem.legs &&  Object.keys(lineItem.legs).length > 0 && lineItem.legs && lineItem.legs.length > 0 && lineItem.legs[0].containerFree) : '',
                        containerFeeDaysHours: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? lineItem.eximTatName : '',
                        bid_remarks: lineItem.bid_remarks || '',
                        bid_withdrawn_price: lineItem.bid_withdrawn_price
                     }}
                     handlingPriceInvoked={this.state.leg.id === lineItem.id && (rfq.type === 2 || rfq.type === 3 || rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) ? handlingPriceInvoked : null}
                     isPriceOptimized={this.state.leg.id === lineItem.id && ((HIKAL.includes(lineItem.companyId) || [15,16,31].includes(leg.rfqType) || (rfq.shippingType !== 1 && [13,14].includes(rfq.type))) ? this.state.leg.linerId === lineItem.linerId : true) && (rfq.type === 2 || rfq.type === 3 || rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) ? isPriceOptimized : null}
                     index={index}
                     submit={((data) => {
                        if (rfq.type === 2 || (rfq.type === 3 && (isAdani ? rfq.rfqDetails.secondaryContractType !== 2 : true)) || rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) {
                           this.isPriceInvoked(false);
                           if(this.state.leg.tat) { 
                              const tat = this.state.leg.tat.tatValue ? {
                                 name: this.state.leg.tat.tatUnit && this.state.leg.tat.tatUnit.tatUnitName || '',
                                 unit: this.state.leg.tat.tatUnit && this.state.leg.tat.tatUnit.tatUnit || 0,
                                 value: this.state.leg.tat.tatValue,
                              } : this.state.leg.tat;
                              data={
                                 ...data,
                                 // tat: this.state.leg.tat.tatValue ,
                                 tat,
                                 isTripPriceUpdated: this.state.isTripPriceUpdated
                              }
                           } else {
                              data = {
                                 ...data,
                                 isTripPriceUpdated: this.state.isTripPriceUpdated
                              }
                           }
                            postBid(lineItem.id, data, this.updateHandlingCharges(this.state.nextApiData));
                        } else {
                           postBid(lineItem.id, data);
                        }
                     })}
                     isLot={lineItem.lotId}
                     trip_id={lineItem.id}
                     tripBids={tripBids}
                     rfq={rfq}
                     isRILCompleteSolution={(rfq && !rfq.rfqDetails.acceptPartialSolution) && rfq.companyId === '737'}
                     pricingBasisName={lineItem.pricingBasisName}
                     showBidStarted = {lineItem.showBidStarted}
                     isWithdrawBid ={lineItem.isWithdrawBid}
                     isAccessBidWithdrawn ={lineItem.isAccessBidWithdrawn}
                     vehicleTypesList ={vehicleTypesList}
                     isRilCPForm={isRilCPForm}
                     systemTime={this.props.systemTime}
                  />
               </span>}
               {lineItem.status && (!lineItem.isWithdrawBid ||  lineItem.isWithdrawBid===undefined) && <div className="ml-15 wt-70">
                  <Status
                     status={lineItem.status}
                     hideText={true}
                  />
               </div>}
               <div className="ml-5">
                  <SEOIcon className="curP fBold fs-18 wt-20 ht-30" onClick={(e) => { e.stopPropagation(); this.setState({ currentIndex: index }); this.setState({ openPopup: true }) }}></SEOIcon>
                  {
                     this.state.currentIndex === index && this.state.openPopup && <OutsideClickHandler
                        onOutsideClick={() => {
                           this.setCurrentIndex(-1);
                        }}>
                        <PostBidPopup
                           biddingDetails={{ price: lineItem.price, tatValue: (lineItem.tat || {}).tatValue, tatUnit: (lineItem.tat || {}).tatUnit }}
                           index={index}
                           tripBids={tripBids}
                           fetchBids={fetchBids}
                           tripId={lineItem.id}
                           linerId={lineItem.linerId}
                           postBid={((data) => {
                              this.setCurrentIndex(-1);
                              if (rfq.type === 2 || rfq.type === 3 || rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) {
                                 postBid(lineItem.id, data, this.updateHandlingCharges(this.state.nextApiData));
                              } else {
                                 postBid(lineItem.id, data);
                              }
                           }).bind(this)}

                        />
                     </OutsideClickHandler>
                  }
               </div>
                   
                   
                     {isDesmet(lineItem.companyId) && <Fragment>
                        <ButtonT11
                         style = {{marginLeft:'20px'}}
                         onClick={() => {
                           this.handleOnClickForViewMaterialsBtn()
                        }}
                      >
                        View Materials
                      </ButtonT11>
                     </Fragment>}



               { 
               lineItem && !lineItem.isWithdrawBid && lineItem.price && rfq.isEnableWithdrawBid && (rfq && rfq.rfqDetails.acceptPartialSolution) && ((this.props.maxCountToWithdrawBid && lineItem.withdraw_bid_count) ? (lineItem.withdraw_bid_count < this.props.maxCountToWithdrawBid) : true) &&
                  <WithDrawBid 
                     index={index}
                     tripId={lineItem.id}
                     rfqId = {rfq.id}
                     linerId={lineItem.linerId}
                     withDrawBid={(data) => {
                        vendorWithDrawBid(data)
                     }}
                     isShowWithDraw ={isShowWithDraw}
                     rfqTypeLtc ={rfq.rfqTypeLtc}
                  /> 
               }
            </div>
               {isAdani && rfq.type == 15 &&
                  <CurrencyConversionDetails currencyDetails={currencyDetails} currencyTypes={currencyTypes} />
               }
         </div>

         {rfq.type !== 8 && <div className="flex-column">
            <div className="fs-12 fs-12 lh-15p theme-color fBold curP" onClick={() => { this.props.openLineItemOverlay(lineItem); this.setCurrentIndex(index) }}>View More</div>
            {/*rfq.type===2 && <div className="fs-12 fs-12 lh-15p theme-color fBold mt-20 curP" onClick={(e) => this.handleShowCharges(true, lineItem, true)}>View Other Cost Charges</div>*/}
            {(rfq.type === 15 && isAdani && lineItem.isNew) && <div className="fs-14 lh-15p error-color fBold mt-20 curP fBold" onClick={(e) => this.handleDeleteLeg(lineItem)}>Delete Leg</div>}
         </div>}
      </div>
      </div>
         {//this.state.showCharges && this.state.leg.id === lineItem.id &&
            (rfq.type === 2 || (rfq.type === 3 && (isAdani ? rfq.rfqDetails.secondaryContractType != 2 : true)) || rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) &&
            <div className="box-shadow br-5 pr mb-50">
            <HandlingCharges
               leg={lineItem} //this.state.leg}
               updateHandlingCharges={this.updateHandlingCharges}
               handleShowCharges={this.handleShowCharges}
               onHCChange={(hcIndex, value, name) => this.onHCChange(hcIndex, value, name, lineItem)}
               isEditBaseRate={true}
               isChargeEdit={(lineItem.isWithdrawBid && !lineItem.isAccessBidWithdrawn) ? false : true}
               isUpdated={leg && leg.multiModeHeadingCharges ? lineItem.multiModeHeadingCharges === leg.multiModeHeadingCharges : false}
               handlePriceUpdate={(data, nextApiData, tat, unit) => this.handlePriceUpdate(data, lineItem, nextApiData, tat, unit)}
               handlePriceUpdateStore={(data, nextApiData, tat, unit) => this.handlePriceUpdateStore(data, lineItem, nextApiData, tat, unit)}
               includesOtherCharges={this.props.rfq.includesOtherCharges}
               showTat={lineItem.showTat}
				   currencyDetails = { currencyDetails}
               currencyTypes={currencyTypes}
               rfq={this.props.rfq}
               seaAndAirLines={seaAndAirLines}
               LegIndex={index}
               allowTransporterToAddCostHeadDuringBidding={allowTransporterToAddCostHeadDuringBidding}
               getPlantWiseCostHeads={getPlantWiseCostHeads}
            />
            {this.renderAddLinersForAwl() && this.renderAddLinersForAwlEximCIF(rfq, lineItem, LinersList)}
            </div>
         }
      </Fragment>
   }
   getHeaderForBidNotStarted(lineItems) {
      const trip = ((lineItems || [])[0] || {});
      // const isQbrShow = ['999', '872'].includes(trip.companyId) ? trip.qbrShowRate : true;
      const isQbrShow = true;
      return <div className="flex flex-between flex-middle ht-60 pl-25 pr-25">
         <div className="fBold fs-16 header-dark-color wt-250">Location</div>
         <div className="fBold fs-16 header-dark-color col-8 pl-15">Unit</div>
         {isQbrShow && !trip.hideCeilingPrice && <div className="fBold fs-16 header-dark-color col-8 pl-15">Ceiling Price</div>}
         <div className="fBold fs-16 header-dark-color col-8 pl-15">Counter</div>
         <div className="fBold fs-16 header-dark-color col-8 pl-15">My Bid</div>
         <div className="fBold fs-16 header-dark-color col-8 pl-15">Bid status</div>
         <div className="fBold fs-16 header-dark-color wt-50 pl-15"></div>
      </div>
   }
   getBodyForBidNotStarted(lineItem, index, categories) {
      const rfq = this.props.rfq;
      
      const cities = lineItem.stops.map((stop) => stop.city);
      // const secKmRun = lineItems.map(e => console.log(e.secKmRun))
      const isACC = (rfq.companyId === ACC)
      const { currencyTypes , systemTime, currencyDetails } = this.props;
      // const isQbrShow = ['999', '872'].includes(lineItem.companyId) ? lineItem.qbrShowRate : true;
      const isQbrShow = true;
      const isAdani = ['999', '872'].includes(lineItem.companyId);
      
      return <Fragment><div onClick={() => { if(rfq.type == 8) { return; } this.props.openLineItemOverlay(lineItem); this.setCurrentIndex(index) }} className="flex flex-between flex-middle border-top-light pt-10 pb-10 bg-hover-light pl-25 pr-25" key={index}>
         <div className="wt-250">
            <div className="fs-14 section-sub-header-color fs-14 lh-15p fRegular">
            {lineItem.container_type_name && <div className='theme-color fBold fs-16'>{lineItem.container_type_name}</div>}
               <span key={index}>
               {GALAXY_SURFACE.includes(lineItem.companyId) ?
                  <>
                  {
                     (lineItem.ftlStops || []).map((stop, index)=> {
                        return (
                           <span>{(stop.location && (stop.location.split(',') || [])[0] || stop.city)}{(((lineItem.ftlStops || []).length - 1) !== index) ? <Back className="wt-10 ml-5 mr-5 mt-5 rotate-180deg" /> : ''}</span>
                        )
                     })
                  }
              </>:
              <>
               {!rfq.enableRouteDescription && lineItem.from}{!rfq.enableRouteDescription && lineItem.stops && lineItem.stops.length > 0 && <>{this.getStopDetails(lineItem.stops, 0)}</>}
               {lineItem.to && 
               <Fragment>
                  {!rfq.enableRouteDescription && <Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" /> }{lineItem.to}{lineItem.stops && lineItem.stops.length > 1 && <>{this.getStopDetails(lineItem.stops, 1)}</>}
               </Fragment>}
               </>}
               </span>
               <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  {lineItem.multi_mode_leg_trip[0] && <span>{lineItem.multi_mode_leg_trip[0].leg_type_name}</span>}
                  {lineItem.rfqType === 6 && lineItem.providerName !== 'Transporter' && lineItem.noOfManPower && <span>{`Man Power: ${lineItem.noOfManPower}`}</span>}
               </div>
               {(CARGIL.includes(rfq.companyId) && lineItem.consigneeTypeName) && <div className="section-sub-header-color fs-12 op-79 lh-15p pt-5">
                  <span>Consignee Type : </span><span className='theme-color'>{lineItem.consigneeTypeName}</span>
               </div> || null}
               {(lineItem.rfqType === 1 && isAdani) && <div><span className='fBold theme-color'>Contract Type: </span><span>{lineItem.contract_type_name}</span></div>}
               {(lineItem.rfqType === 12 && isAdani) && <div className={'fs-12'}><span className='fBold theme-color'>Border Location: </span><span className={'error-color ml-3 fBold'}>{(lineItem.borderLocation || {}).location}</span></div>}
               {isDesmet(rfq.companyId) && ((lineItem.consigners || [])[0] || {}).company_name && <div className='fs-12 mt-3'><span className='fBold theme-color'>Consignor: </span><span>{`${((lineItem.consigners || [])[0] || {}).company_name}, ${((lineItem.consigners || [])[0] || {}).address}`}</span></div>}
               {isDesmet(rfq.companyId) && ((lineItem.consignees || [])[0] || {}).company_name && <div className='fs-12 mt-3'><span className='fBold theme-color'>Consignee: </span><span>{`${((lineItem.consignees || [])[0] || {}).company_name}, ${((lineItem.consignees || [])[0] || {}).address}`}</span></div>}
            </div>
            <div className="section-sub-header-color fs-12 lh-15p pt-5">
               {lineItem.biddingDetails.businessVolumeValue ? <Fragment>{(rfq.type === 3 && isAdani ? 'Business Volume(MT): ' : (CARGIL.includes(rfq.companyId) ? 'Business Volume: ' : ''))} {lineItem.biddingDetails.businessVolumeValue} {lineItem.biddingDetails.businessVolumeUnitName} . </Fragment> : null}
               {(CARGIL.includes(rfq.companyId) && (lineItem.biddingDetails || {}).businessVolumeValue) && <br/> || ''}
               {this.shouldRenderPickupDropPoint(lineItem) ? <div><span className="vehicle-pickup-drop-span">{lineItem.noOfPickups} {'Pickups |'} {lineItem.noOfDrops} {'Drops'}</span>
                  <a data-tip data-for={`scrollContent-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">i</span> </a>
                  <ReactTooltip
                     id={`scrollContent-${index}`}
                     type="light"
                     effect="solid"
                     place="right"
                     className="tooltip-trip-shadow"
                     delayHide={100}
                  >
                     <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                        <section className="flex mt-25 flex-column">
                           <RFQFTLTripsTable lineItem={lineItem} />
                        </section>
                     </div>
                  </ReactTooltip>
               </div>
                  :
                  <span>{lineItem.noOfPickups} {'Pickup |'} {lineItem.noOfDrops} {'Drop'}</span>}
            </div>
            {lineItem.vehicleTypeName && <div className="section-sub-header-color fs-12 op-79 lh-15p ">
               {lineItem.vehicleTypeName}, {lineItem.vehicleBodyTypeName}
            </div>}
            
            {(lineItem.placementTime) && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
               Placement Time: <span className="fBold">{lineItem.placementTimeFormatted}</span>
            </div>}

            {
               !isACC && lineItem.distance &&
               <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  {lineItem.distance} {lineItem.distanceUOM}
               </div>
            }
            { 
                lineItem.vehicleRemarks &&
               <span className="fs-12 op-79 lh-15p theme-color">{lineItem.vehicleRemarks}</span>
            }
            {rfq.type === 3 && isAdani && (rfq.rfqDetails || {}).secondaryContractType === 2 && <div className="section-sub-header-color fs-14 op-79 lh-15p ">
                  Slab (MT):  <span className="fBold">{lineItem.fromRange} - {lineItem.toRange}</span>
               </div>}
               {rfq && (rfq.rfqDetails || {}).ftlContractType === 2 && <div className="section-sub-header-color fs-14 op-79 lh-15p ">
               Slab:  <span className="fBold">{lineItem.fromRange} - {lineItem.toRange}</span>
            </div>}
            {lineItem.slab_name && <div className='mt-5 fs-14'>
               <span className='fBold theme-color'>{`Slab${lineItem.pricingBasisName ? `(${lineItem.pricingBasisName})` : ''}: `} </span> <span>{lineItem.slab_name}</span>
            </div> || ''}
               {rfq.type === 3 && isAdani && (rfq.rfqDetails || {}).secondaryContractType === 1 &&
                  <>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        Carrying Capacity(MT):  <span className="fBold">{lineItem.carryingCapacity}</span>
                     </div>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        Fixed km/Month:  <span className="fBold">{lineItem.fixedKmPerMonth}</span>
                     </div>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        Extra cost/km :  <span className="fBold">{lineItem.extraCostPerKm && formatToINR(lineItem.extraCostPerKm)}</span>
                     </div>
                  </>
               }
               {rfq.type === 8 &&
                  <>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        Quantity:  <span className="fBold">{lineItem.total_estimated_qty}</span>
                     </div>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        UOM:  <span className="fBold">{lineItem.uom}</span>
                     </div>
                  </>
               }
            {
               categories &&
               <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  <b className="op-full fBold header-dark-color">Product Type:</b> {lineItem.productCategoryTypeName}
               </div>
            }
            <div className="section-sub-header-color fs-12 op-79 lh-15p ">
               {
                  !!((lineItem.challengePrice !== lineItem.price) &&
                     lineItem.cpState !== CHALLENGE_PRICE_SENT &&
                     lineItem.tripBidEnd && !lineItem.isLoiSent &&
                     !(lineItem.isAccept === true) && !(lineItem.isAccept === false) &&
                     lineItem.tripBidEnd && new Date(lineItem.tripBidEnd).getTime() > 0 &&
                     // new Date().getTime() < new Date(lineItem.tripBidEnd).getTime()) &&
                     systemTime < new Date(lineItem.tripBidEnd).getTime()) &&
                  <Timer from={lineItem.biddingDetails.from} to={lineItem.tripBidEnd} currentTime={systemTime} />
               }
            </div>
         </div>
         <div className="col-8 pl-15 section-sub-header-color fs-14 lh-15p pl-15">
            km/ {lineItem.biddingDetails.businessVolumeUnitName}
         </div>
         {(isQbrShow  && lineItem.showCeilingPriceBeforeBidStart &&!lineItem.hideCeilingPrice) ?<div className="fs-14 section-sub-header-color col-8 pl-15">
           {formatToINR(lineItem.biddingDetails.qbr)}
         </div>: (!lineItem.biddingDetails.from >systemTime)? <div className="fs-14 section-sub-header-color col-8 pl-15">
            {formatToINR(lineItem.biddingDetails.qbr)}
         </div>: ''}

         <div className="fs-14 section-sub-header-color col-8 lh-15p pr pl-15">
            -
            </div>
         <div className="fs-14 section-sub-header-color col-8 lh-15p pr pl-15">
            -
            </div>
         <div className="fs-14 section-sub-header-color col-8 lh-15p wt-100 pl-15">-</div>
         <div className="fs-14 fs-14 lh-15p theme-color underline wt-50 curP pl-15" onClick={() => { this.props.openLineItemOverlay(lineItem); this.setCurrentIndex(index) }}> <Open /></div>
      </div>
      
         {/*rfq.type===2 && <div className="fs-12 fs-12 lh-15p theme-color fBold pl-20 pb-10 curP" onClick={(e) => this.handleShowCharges(true, lineItem, false)}>View Other Cost Charges</div>*/}
         {//this.state.showCharges && this.state.leg.id === lineItem.id &&
            ((rfq.type === 3 && (isAdani ? rfq.rfqDetails.secondaryContractType != 2 : true)) || rfq.type === 2 || rfq.type === 5 || [13, 14, 15, 16, 31].includes(rfq.type)) &&
            <HandlingCharges
               leg={lineItem} //this.state.leg}
               updateHandlingCharges={this.updateHandlingCharges}
               handleShowCharges={this.handleShowCharges}
               onHCChange={(hcIndex, value, name) => this.onHCChange(hcIndex, value, name, lineItem)}
               isEditBaseRate={true}
               isChargeEdit={this.state.isChargeEdit}
               handlePriceUpdate={(data, nextApiData, tat, unit) => this.handlePriceUpdate(data, lineItem, nextApiData, tat, unit)}
               includesOtherCharges={this.props.rfq.includesOtherCharges}
               showTat={lineItem.showTat}
					currencyDetails={currencyDetails}
               currencyTypes={currencyTypes}
               rfq={this.props.rfq}
               LegIndex={index}
            />
         }

      </Fragment>
   }
   getHeaderForBidCompleted(isRilCPForm, loicount, lineItems, rfq) {
      const trip = ((lineItems || [])[0] || {});
      // const isQbrShow = ['999', '872'].includes(trip.companyId) ? trip.qbrShowRate : true;
      const isLOISentToShowCP = ((lineItems || []).filter(lineItem => (lineItem.isLoiSent || (!lineItem.isLoiSent && lineItem.isAccept === false))) || []);
      const isQbrShow = true;
      const { acceptOrRejectLoiList } = this.state;
      let rejectCount = (acceptOrRejectLoiList || []).filter(el => !el.l1AcceptMandatory).length;

      return <div className="flex flex-between flex-middle pl-25 pr-25 flex-middle">
         <div className="fBold fs-16 header-dark-color wt-250">Location</div>
         {isQbrShow && !trip.hideCeilingPrice && <div className="fBold fs-16 header-dark-color flex-1 pl-15">Ceiling Price / TAT</div>}
         <div className="fBold fs-16 header-dark-color flex-1 pl-15">My Bid
         {(this.props.rfq && !this.props.rfq.rfqDetails.acceptPartialSolution) && 
         <>
            {this.props.totalValueVisibilityOnProvider && trip.sum_of_product_price && <div className="fBold fs-12 theme-color">Total Value {this.props.visibilityOfLotRankingForProvider && trip.sum_order_text && `(${trip.sum_order_text})`} :₹{trip.sum_of_product_price.toFixed(1).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
            {this.props.totalValueVisibilityOnProvider && trip.sum_price_volume_mt && <div className="fBold fs-12 theme-color">Total Value (MT) {this.props.visibilityOfLotRankingForProvider && trip.sum_order_text && `(${trip.sum_order_text})`} :₹{trip.sum_price_volume_mt.toFixed(1).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
            {this.props.totalValueVisibilityOfL1OnProvider && trip.sum_order_text !== 'L1' && trip.sum_lowest_price && <div className="fBold fs-12 success-color">Total Value(L1):₹{trip.sum_lowest_price.toFixed(1).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
            {this.props.totalValueVisibilityOfL1OnProvider && trip.sum_order_text !== 'L1' && trip.lowest_price_volume_mt && <div className="fBold fs-12 success-color">Total Value(MT) (L1):₹{trip.lowest_price_volume_mt.toFixed(1).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</div>}
         </>
         }
         </div>
         {isRilCPForm && (['737'].includes(trip.companyId) ? isLOISentToShowCP.length > 0 : true) && rfq.type !== 5 && <div className="fBold fs-16 header-dark-color flex-1 pl-15">{!lineItems.isWithdrawBid && 'Challenge Price'}</div>}
         {isRilCPForm && rfq.type !== 5 && <div className="fBold fs-16 header-dark-color wt-250 pl-15">{!lineItems.isWithdrawBid && "Counter"}</div>}
         {(['737'].includes(trip.companyId) ? !(rfq && !rfq.rfqDetails.acceptPartialSolution) : true ) && <input type="checkbox" name="acceptorrejectlois" className="mt--25" checked={this.state.isChecked} onClick={(e) => { e.stopPropagation(); this.selectAllLoi(e, lineItems) }} />}
         <div className="fBold fs-16 header-dark-color wt-140 pl-10">Status
               {rfq.type === 8 &&
                  <>
                  <span className="theme-color fs-14 curP mt-5 tCenter ml-10" onClick={(e) => {
                     e.stopPropagation();
                     location.href = "/poformat/" + rfq.id + "/" + rfq.type;
                  }}>View PO</span>
                  </>
               }
                <div>
                <span className="fBold fs-16 theme-color pt-5 curP pr pl-15" onClick={(e) => { e.stopPropagation(); this.postBidList(2) }}>{`Accept All ${(['737', ...STAR_CEMENT].includes(trip.companyId) && (rfq && !rfq.rfqDetails.acceptPartialSolution)) ? ''  : `(${loicount})`}`}</span>
                <span className="fBold fs-16 theme-color pt-5 curP pr pl-15" onClick={(e) => { e.stopPropagation(); this.postBidList(3) }}>{`Reject All ${(['737', ...STAR_CEMENT].includes(trip.companyId) && (rfq && !rfq.rfqDetails.acceptPartialSolution)) ? ''  : `(${rejectCount})`}`}</span>
            </div>
           
         </div>
      </div>
   }

   getBodyForBidCompleted(lineItem, index, categories, isRilCPForm) {
      const { acceptOrRejectLoiList } = this.state;
      const rfq = this.props.rfq;
      const isACC = (rfq.companyId === ACC);
      const cities = lineItem.stops.map((stop) => stop.city);
		const { postChallengePrice, paymentBasis, systemTime, tripBids, fetchBids, currencyDetails, currencyTypes , postBid} = this.props;
      const cType = (currencyTypes || []).find(el => el.currency_type == lineItem.legCostValue) || {};
      // const isQbrShow = ['999', '872'].includes(lineItem.companyId) ? lineItem.qbrShowRate : true;
      const isQbrShow = true;
      const isLTCCompleteSolution = (rfq.rfqTypeLtc === "LTC" && rfq && !rfq.rfqDetails.acceptPartialSolution);
      const isLOISentToShowCP = ((this.props.lineItems || []).filter(lineItem => (lineItem.isLoiSent || (!lineItem.isLoiSent && lineItem.isAccept === false))) || []);
      const isAdani = ['999', '872'].includes(lineItem.companyId);
      const isCargil = CARGIL.includes(lineItem.companyId);
      const beam = BEAM.includes(lineItem.companyId);
      const actions = getUser().actions;
      const legName = ((rfq.type == 15 && getLegLabel(lineItem, this.props.lineItems, index)) || '');
      
      return <Fragment>
         <div 
            onClick={() => { if(rfq.type == 8) { return; }  this.props.openLineItemOverlay(lineItem); this.setCurrentIndex(index) }} 
            className="border-top-light pt-10 pb-10 bg-hover-light pl-25 pr-25" 
            key={index}
         >
         {rfq.isShowObdsDetails &&
            this.getObdsDetailsData(lineItem)
         }
         <div className="flex fSemibold flex-between flex-middle">
            <div className="wt-250 curP">

            {/* { rfq.isShowObdsDetails &&
             this.getObdsName()
             } */}
            
               <div className="fs-14 section-sub-header-color fs-14 lh-15p fRegular">
                     {(HIKAL.includes(lineItem.companyId) || [15,16,31].includes(lineItem.rfqType) || (rfq.shippingType !== 1 && [13, 14].includes(lineItem.rfqType))) && <div className='theme-color fBold fs-16'>{isAdani ? legName : `Liner ${index + 1}`}</div>}
               {lineItem.container_type_name && <div className='theme-color fBold fs-16'>{lineItem.container_type_name}</div>}
            <div className={'flex flex-middle'} key={index}>{GALAXY_SURFACE.includes(lineItem.companyId) ?
               <>
                  {
                     (lineItem.ftlStops || []).map((stop, index)=> {
                        return (
                           <span>{(stop.location && (stop.location.split(',') || [])[0] || stop.city)}{(((lineItem.ftlStops || []).length - 1) !== index) ? <Back className="wt-10 ml-5 mr-5 mt-5 rotate-180deg" /> : ''}</span>
                        )
                     })
                  }
               </> :
               <>{!rfq.enableRouteDescription && lineItem.from}{!rfq.enableRouteDescription && lineItem.stops && lineItem.stops.length > 0 && <>{this.getStopDetails(lineItem.stops, 0)}</>} {lineItem.to && <Fragment> {!rfq.enableRouteDescription && <Back className=" ml-5 mr-5 black-color mt-5 rotate-180deg" />}{lineItem.to}{lineItem.stops && (lineItem.stops).length > 1 && <>{this.getStopDetails(lineItem.stops, 1)}</>}</Fragment>}</>}</div>
               <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  {lineItem.multi_mode_leg_trip[0] && <span>{lineItem.multi_mode_leg_trip[0].leg_type_name}</span>}
                  {lineItem.rfqType === 6 && <span>{lineItem.providerName === 'Transporter' ? 'Transportation Charges' : `${lineItem.providerName} charges`}</span>}
                  {lineItem.rfqType === 6 && lineItem.providerName !== 'Transporter' && lineItem.noOfManPower && <span>{`Man Power: ${lineItem.noOfManPower}`}</span>}
               </div>
               {isDesmet(rfq.companyId) && ((lineItem.consigners || [])[0] || {}).company_name && <div className='fs-12 mt-3'><span className='fBold theme-color'>Consignor: </span><span>{`${((lineItem.consigners || [])[0] || {}).company_name}, ${((lineItem.consigners || [])[0] || {}).address}`}</span></div>}
               {isDesmet(rfq.companyId) && ((lineItem.consignees || [])[0] || {}).company_name && <div className='fs-12 mt-3'><span className='fBold theme-color'>Consignee: </span><span>{`${((lineItem.consignees || [])[0] || {}).company_name}, ${((lineItem.consignees || [])[0] || {}).address}`}</span></div>}
               {(CARGIL.includes(rfq.companyId) && lineItem.consigneeTypeName) && <div className="section-sub-header-color fs-12 op-79 lh-15p pt-5">
                  <span>Consignee Type : </span><span className='theme-color'>{lineItem.consigneeTypeName}</span>
               </div> || null}
               {(lineItem.rfqType === 1 && isAdani) && <div><span className='fBold theme-color'>Contract Type: </span><span>{lineItem.contract_type_name}</span></div>}
               {(lineItem.rfqType === 12 && isAdani) && <div className={'fs-12'}><span className='fBold theme-color'>Border Location: </span><span className={'error-color ml-3 fBold'}>{(lineItem.borderLocation || {}).location}</span></div>}
            </div>
            
            <div className="section-sub-header-color fs-12 lh-15p pt-5">
               {lineItem.biddingDetails.businessVolumeValue ? <Fragment>{(rfq.type === 3 && isAdani ? 'Business Volume(MT): ' : '')} {lineItem.biddingDetails.businessVolumeValue} {lineItem.biddingDetails.businessVolumeUnitName} . </Fragment> : null}
               {this.shouldRenderPickupDropPoint(lineItem) ? <div><span className="vehicle-pickup-drop-span">{lineItem.noOfPickups} {'Pickups |'} {lineItem.noOfDrops} {'Drops'}</span>
                  <a data-tip data-for={`scrollContent-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">i</span> </a>
                  <ReactTooltip
                     id={`scrollContent-${index}`}
                     type="light"
                     effect="solid"
                     place="right"
                     className="tooltip-trip-shadow"
                     delayHide={100}
                  >
                     <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                        <section className="flex mt-25 flex-column">
                           <RFQFTLTripsTable lineItem={lineItem} />
                        </section>
                     </div>
                  </ReactTooltip>
               </div>
                  :
                  <>{lineItem.rfqType !== 6 && <span>{lineItem.noOfPickups} {'Pickup |'} {lineItem.noOfDrops} {'Drop'}</span>} </>}
            </div>

               {/* {rfq.type !== 3 && lineItem.vehicleTypeName && <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  {lineItem.vehicleTypeName}, {lineItem.vehicleBodyTypeName}
               </div>} */}
               {lineItem.vehicleTypeName && <div className="section-sub-header-color fs-12 op-79 lh-15p theme-color">
                  {lineItem.vehicleTypeName}, {lineItem.vehicleBodyTypeName}
               </div>}

               {(lineItem.placementTime) && <div className="section-sub-header-color fs-12 op-79 lh-15p mt-5">
                    Placement Time: <span className="fBold">{lineItem.placementTimeFormatted}</span>
                  </div>}

               {isVishaka(rfq.companyId) &&
                     (lineItem?.biddingDetails?.cargoQuantity || {})
                     &&
                     <span className="section-sub-header-color fs-12 mt-5 mb-5 op-79"><b>Cargo Weight:</b> {lineItem?.biddingDetails?.cargoQuantity} {rfq?.packing_type_name}</span>
               }

               {isVishaka(rfq.companyId) &&
                     lineItem.vehicle_placement_schedule &&
                     <div><span className="vehicle-pickup-drop-span">

                        <FaTruck className="theme-color fs-18" />
                     </span>
                        <a data-tip data-for={`scrollContent-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">i</span> </a>
                        <ReactTooltip
                           id={`scrollContent-${index}`}
                           type="light"
                           effect="solid"
                           place="right"
                           className="tooltip-trip-shadow"
                           delayHide={100}
                        >
                           <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                              <section className="flex mt-25 flex-column">
                                 <VehiclePlaceSceduleTable lineItem={lineItem} />
                              </section>
                           </div>
                        </ReactTooltip>
                     </div>
               }
               {isVishaka(rfq.companyId) &&
                     lineItem.vehicleRemarks &&
                     <span className="fs-12 op-79 lh-15p theme-color">{lineItem.vehicleRemarks}</span>
               }

               {rfq.type === 3 && (isAdani ? lineItem.distance : true) && !["737"].includes(lineItem.companyId) && <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  By Road -
               </div>}
               {
                  !isACC && lineItem.distance &&
                  <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                     {lineItem.distance} {lineItem.distanceUOM}
                     </div>
                  }
                  {!(isCoromandel(rfq.companyId) || isVishaka(rfq.companyId)) &&
                     lineItem.vehicleRemarks &&
                     <div className="fs-12 lh-15p mt-3">
                        <span className="fSemibold header-dark-color">Remarks: </span>
                        <span className="theme-color">{lineItem.vehicleRemarks}</span>
                     </div>
                  }
                  {!isCoromandel(rfq.companyId) && <>
                     {(lineItem.tripContractTenureFrom || lineItem.tripContractTenureTo) && (
                        <div className="fs-12 lh-15p pb-5">
                           <span className="fSemibold header-dark-color">Contract Tenure: </span>
                           {lineItem.tripContractTenureFrom && (
                              <span className="fSemibold header-dark-color">
                                 {Moment(lineItem.tripContractTenureFrom).format('Do MMM, YYYY')}
                              </span>
                           )}
                           {lineItem.tripContractTenureTo && (
                              <span>
                                 {' To '}
                                 <span className="fSemibold header-dark-color">
                                    {Moment(lineItem.tripContractTenureTo).format('Do MMM, YYYY')}
                                 </span>
                              </span>
                           )}
                        </div>
                     )}
                     {isAdani && lineItem.pendingTripContractTenureFrom && lineItem.pendingTripContractTenureTo && (
                        <div className="fs-12 lh-15p pb-5 header-dark-color">
                           {'Changed Contract Tenure: '}
                           <span className="fBold orange-color">{Moment(lineItem.pendingTripContractTenureFrom).format('Do MMM, YYYY')}</span>
                           {' To '}
                           <span className="fBold orange-color">{Moment(lineItem.pendingTripContractTenureTo).format('Do MMM, YYYY')}</span>
                        </div>
                     )}
                  </>}
               {(isCoromandel(rfq.companyId) || isVishaka(rfq.companyId)) && lineItem.tripContractTenureFrom && lineItem.tripContractTenureTo &&<span className="fs-12">
                     <br />
                  Extended Contract Tenure:
                     {lineItem.tripContractTenureFrom && <span className="fs-12 op-79 lh-15p pb-5 orange-color fBold">{Moment(lineItem.tripContractTenureFrom).format('Do MMM, YYYY')} </span>}
                     {lineItem.tripContractTenureTo && <span className="fs-12 op-79 lh-15p pb-5">To  <span className='orange-color fBold'>{Moment(lineItem.tripContractTenureTo).format('Do MMM, YYYY')} </span></span>}
                  </span>
               }
               {(isCoromandel(rfq.companyId) || isVishaka(rfq.companyId)) && lineItem.seekerInstructions && <span className="fs-12">
                     <br />
                     Seeker Remarks:
                     <span className="fs-12 op-79 lh-15p theme-color"> {lineItem.seekerInstructions}</span>
                  </span>
               }
               {(lineItem.tripContractTenureTo && lineItem.tripContractTenureTo  > new Date()) ? <span className='fs-14 fBold success-color'>Active</span> : (lineItem.tripContractTenureTo && lineItem.tripContractTenureTo  < new Date()) ? <span className='fs-14 fBold error-color'> Expired </span>:""}
               {rfq.type === 3 && isAdani && (rfq.rfqDetails || {}).secondaryContractType === 2 && <div className="section-sub-header-color fs-14 op-79 lh-15p ">
                  Slab (MT):  <span className="fBold">{lineItem.fromRange} - {lineItem.toRange}</span>
               </div>}
               {rfq && (rfq.rfqDetails || {}).ftlContractType === 2 && <div className="section-sub-header-color fs-14 op-79 lh-15p ">
               Slab:  <span className="fBold">{lineItem.fromRange} - {lineItem.toRange}</span>
            </div>}
            {lineItem.slab_name && <div className='mt-5 fs-14'>
               <span className='fBold theme-color'>{`Slab${lineItem.pricingBasisName ? `(${lineItem.pricingBasisName})` : ''}: `}</span> <span>{lineItem.slab_name}</span>
            </div> || ''}
               {rfq.type === 3 && isAdani && (rfq.rfqDetails || {}).secondaryContractType === 1 &&
                  <>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        Carrying Capacity(MT):  <span className="fBold">{lineItem.carryingCapacity}</span>
                     </div>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        Fixed km/Month:  <span className="fBold">{lineItem.fixedKmPerMonth}</span>
                     </div>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        Extra cost/km :  <span className="fBold">{lineItem.extraCostPerKm && formatToINR(lineItem.extraCostPerKm)}</span>
                     </div>
                  </>
               }
               {rfq.type === 8 &&
                  <>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        Quantity:  <span className="fBold">{lineItem.total_estimated_qty}</span>
                     </div>
                     <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                        UOM:  <span className="fBold">{lineItem.uom}</span>
                     </div>
                  </>
               }
            {
               categories &&
               <div className="section-sub-header-color fs-12 op-79 lh-15p ">
                  <b className="op-full fBold header-dark-color">Product Type:</b> {lineItem.productCategoryTypeName}
               </div>
            }
            <div className="section-sub-header-color fs-12 op-79 lh-15p ">
               {
                  !!((lineItem.challengePrice !== lineItem.price) &&
                     lineItem.cpState !== CHALLENGE_PRICE_SENT &&
                     lineItem.tripBidEnd && !lineItem.isLoiSent &&
                     !(lineItem.isAccept === true) &&
                     !(lineItem.isAccept === false) &&
                     lineItem.tripBidEnd &&
                     new Date(lineItem.tripBidEnd).getTime() > 0 &&
                     // new Date().getTime() < new Date(lineItem.tripBidEnd).getTime()) &&
                     systemTime < new Date(lineItem.tripBidEnd).getTime()) &&
                  <Timer from={lineItem.biddingDetails.from} to={lineItem.tripBidEnd} currentTime={systemTime} />
               }
            </div>
            {
               // lineItem.relayEndTime &&
               // lineItem.relayEndTime > systemTime &&
               // lineItem.biddingDetails.to < systemTime &&
               // <Timer 
               //     from={lineItem.biddingDetails.to} 
               //     to={lineItem.relayEndTime} 
               //     currentTime={systemTime}
               // />
            }
         </div>
         {isQbrShow && !lineItem.hideCeilingPrice && <div className="flex-1 pl-15 section-sub-header-color fs-14 lh-15p ">
            {rfq.type !== 6 && formatToINR(lineItem.biddingDetails.qbr)}
            {rfq.type === 6 && formatToINR(lineItem.qbr)}
            {lineItem.priceInBaseCurrency !== 'INR' && lineItem.biddingDetails[`qbr_${lineItem.priceInBaseCurrency === 'USD' ? 'usd' : 'secondary'}`] && <span className="ml-5 mr-5">{lineItem.priceInBaseCurrencySymbol || ''}{lineItem.biddingDetails[`qbr_${lineItem.priceInBaseCurrency === 'USD' ? 'usd' : 'secondary'}`]}</span>}
            
            {
               lineItem.biddingDetails.tatValue ?
               <React.Fragment>
                  / {lineItem.biddingDetails.tatValue}  {lineItem.biddingDetails.tatUnitName}
               </React.Fragment> : null
            }
         </div>}
         <div className="fs-14 section-sub-header-color flex-1 pl-15 ">
            {lineItem.tat && <span>
              {formatToINR(lineItem.price)} {lineItem[`price${lineItem.priceInBaseCurrency === 'USD' ? 'USD' : 'Secondary'}`] && <span className="ml-5 mr-5">{lineItem.priceInBaseCurrencySymbol || ''}{lineItem[`price${lineItem.priceInBaseCurrency === 'USD' ? 'USD' : 'Secondary'}`]}</span>} / {lineItem.tat.tatValue} {lineItem.tat.tatUnit && lineItem.tat.tatUnit.tatUnitName}
            </span>}
            {isDesmet(rfq.companyId) && 
               <> {(lineItem.transporter_vehicle || []).length > 0 && <div className='fs-12 mt-5'>
                        <table border={1} cellSpacing={0} cellPadding={1}>
                        <tr className='caption-color mr-5 fs-12'>
                           <th>Vehicle Type</th>
                           <th>No. of Vehicle</th>
                           <th>Price / Vehicle</th>
                           <th>Total Price</th>
                        </tr>
                        {lineItem.transporter_vehicle.length > 1 && 
                           <tr>
                              <td>Multiple Vehicle</td>
                              <td></td>
                              <td></td>
                              <td>{this.getTotalForMultipleVehicle(lineItem)}</td>
                           </tr>}
                        {(lineItem.transporter_vehicle || []).map((trans, tIndex) => {
                        return (<tr key={tIndex}>
                                    <td className='tCenter'>
                                       <div>{trans.name}</div>
                                       {trans.vehicle_size && <div className='mt-5`'>{`Vehicle Size: ${trans.vehicle_size}`}</div>}
                                    </td>
                                    <td className='tCenter'>
                                       <input
                                          value={this.getInputValue('number_of_vehicle', trans.number_of_vehicle, lineItem.id, tIndex)}
                                          placeholder="Number of vehicle"
                                          name="number_of_vehicle"
                                          onChange={(e) => this.changeTransVehicle(e, lineItem, tIndex)}
                                          className="col-1 fs-14 no-border ht-30"
                                          style={{
                                             border: 'none',
                                             borderBottom: 'solid 1px #d8dbf0',
                                             background: 'transparent'
                                          }}
                                          noTransition={true}
                                          step="any"
                                          containerClassName="no-transition-container"
                                       />
                                    </td>
                                    <td className='tCenter'>
                                       <input
                                          value={this.getInputValue('price_per_vehicle', trans.price_per_vehicle, lineItem.id, tIndex)}
                                          placeholder="Number of vehicle"
                                          name="price_per_vehicle"
                                          onChange={(e) => this.changeTransVehicle(e, lineItem, tIndex)}
                                          className="col-1 fs-14 no-border ht-30"
                                          style={{
                                             border: 'none',
                                             borderBottom: 'solid 1px #d8dbf0',
                                             background: 'transparent'
                                          }}
                                          noTransition={true}
                                          step="any"
                                          containerClassName="no-transition-container"
                                       />
                                    </td>
                                    <td className='tCenter'>{this.getInputValue('price', trans.price, lineItem.id, tIndex)}</td>
                                 </tr>)})}
                     </table>
                  </div>}
               </>}
               {isAdani && rfq.type == 15 && <CurrencyConversionDetails currencyDetails={currencyDetails} currencyTypes={currencyTypes} />}
            {isSapDPL(rfq.companyId) &&
               <div>
                  {!!lineItem.dph_from_date && !!lineItem.dph_to_date &&
                  <>
                  <p>DPH Validity:</p>
                  <p className='mt--10'>{Moment(lineItem.dph_from_date).format('DD MMM YYYY')}-{Moment(lineItem.dph_to_date).format('DD MMM YYYY')}</p>
                  </>}
                  {!!lineItem.revised_price &&
                  <p>Revised Price:{lineItem.revised_price}&nbsp;{!!lineItem.pricingBasisName && lineItem.pricingBasisName}</p>}
               </div>}
         {lineItem.is_loi_cp_allocation_to_allocated_vendor && <span>
                  <a data-tip data-for={`scrollContent-product-${index}`} data-iscapture='true'> <span className="tooltip-icon fBold">A</span> </a>
                  <ReactTooltip
                     id={`scrollContent-product-${index}`}
                     type="light"
                     effect="solid"
                     place="right"
                     className="tooltip-trip-shadow"
                     delayHide={100}
                  >
                     <div className="flex-1 flex-column ht-1000 overflowAuto br-5" data-scroll-hide="true">
                        <section className="flex mt-25 flex-column">
                           <ProductAllocation lineItem={lineItem} />
                        </section>
                     </div>
                  </ReactTooltip>
               </span>}
         {
            lineItem.isLoiSent && lineItem.isAccept === true && lineItem.share_of_business_percentage && ROQUETTE.includes(lineItem.companyId) &&
            <div className="fs-12 mt-5 flex">SOB: <span className='theme-color fs-14 ml-5'>{lineItem.share_of_business_percentage}%</span></div>
         }
         {lineItem.dph_show_recipient && <>
            {
               (lineItem.approved_dph_percentage || lineItem.dph_percentage || lineItem.dph_amount) &&
               <div className="fs-12 mt-5 flex">
               {lineItem.dph_uom == 2 ?
               <>PR Amount: <span className='theme-color fs-14 ml-5'>{lineItem['dph_amount']}</span></> :
               <>{`${isCargil ? 'PR' : 'DPH'} Percentage`}: <span className='theme-color fs-14 ml-5'>{lineItem['approved_dph_percentage'] || lineItem['dph_percentage']}%</span></>}
               {(lineItem['approved_dph_price_increase'] || lineItem['dph_price_increase']) ? <UpArrow className="ht-15 wt-20"/> : <DownArrow className="ht-15 wt-20"/>}</div>
            }
            {
               (lineItem['approved_revised_price'] || lineItem['revised_price']) && 
               <div className="fs-12 mt-5 flex">Revised Price:<span className='theme-color fs-14 fBold ml-5 mt--3'>₹{(lineItem['approved_revised_price'] || lineItem['revised_price']) && (lineItem['approved_revised_price'] || lineItem['revised_price']).toFixed(2)}</span></div>
            }
            {
               (lineItem['approved_dph_from_date'] || lineItem['dph_from_date']) && (lineItem['approved_dph_to_date'] || lineItem['dph_to_date']) && 
               <div className="fs-12 mt-5 mb-5">{`${isCargil ? 'PR' : 'DPH'} Validity`}: {isCargil && <SEOIcon className="curP fBold fs-18 wt-20 ht-30" onClick={(e) => { e.stopPropagation(); this.props.showPRDetails(lineItem.id) }}></SEOIcon>}
               <br/><div className='theme-color fs-13'>{(lineItem['approved_dph_from_date'] || lineItem['dph_from_date']) && Moment(lineItem['approved_dph_from_date'] || lineItem['dph_from_date']).format('DD MMM YYYY')} - {(lineItem['approved_dph_to_date'] || lineItem['dph_to_date']) && Moment(lineItem['approved_dph_to_date'] || lineItem['dph_to_date']).format('DD MMM YYYY')}</div></div>
            }
         </>}
         </div>
         {
            <div className="fs-14 flex-1 lh-15p pr pl-15">
                     {isRilCPForm && (['737'].includes(lineItem.companyId) ? isLOISentToShowCP.length > 0 : true) && rfq.type !== 5 && (![13, 14, 15, , 16, 31].includes(rfq.type)) &&
            <div className="fs-14 challenge-color flex-1 fs-14 lh-15p pr pl-15">
               {(['737'].includes(lineItem.companyId) ? ((lineItem.isLoiSent || (!lineItem.isLoiSent && lineItem.isAccept === false))) : true) && <>
               {!lineItem.isWithdrawBid &&  lineItem.challengePrice && formatToINR(lineItem.challengePrice)}
               {lineItem[`challengePrice${cType.currency_type === 3 ? 'Secondary' : 'USD'}`] && <span className="ml-5 mr-5">{cType.currency_symbol || '$'}{lineItem[`challengePrice${cType.currency_type === 3 ? 'Secondary' : 'USD'}`]}</span>}
               {
                  formatToINR(lineItem.challengePrice) && lineItem.challengePrice !== 0 &&
                  lineItem.challengePrice < lineItem.price &&
                  lineItem.challengePrice !== undefined &&
                  lineItem.cpState === CHALLENGE_PRICE_SENT && rfq.challengePriceWithAcceptOrReject &&
                  lineItem.counterStatus !== COUNTER_ACCEPT &&
                  lineItem.isAccept !== true && lineItem.isLoiWithCPSent !== true &&
                  !['737'].includes(lineItem.companyId) &&
                  ((ROQUETTE.includes(lineItem.companyId) || (lineItem.CPAcceptValidFrom && lineItem.CPAcceptValidTo)) ? lineItem.CPAcceptValidFrom && lineItem.CPAcceptValidTo && lineItem.CPAcceptValidFrom <= systemTime &&
                  lineItem.CPAcceptValidTo >= systemTime : true) &&

                  // !this.state.hideChallengePriceApprovals.includes(lineItem.id) &&
                  <React.Fragment>
                     <AcceptIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('accept', lineItem)} />
                     <RejectIcon className="wt-20 ht-20 ml-5 curP z-100" onClick={() => this.handleChallengePrice('reject', lineItem)} />
                  </React.Fragment>
               }
               </>}
               </div>}
               {(lineItem.CPAcceptValidFrom && lineItem.CPAcceptValidTo) && <>
                  {  lineItem.CPAcceptValidFrom && lineItem.CPAcceptValidTo &&
                     lineItem.CPAcceptValidTo < systemTime && ![CHALLENGE_PRICE_REJECTED, CHALLENGE_PRICE_ACCEPTED].includes(lineItem.cpState) &&
                     <div className='error-color'>CP Ignored</div>
                  }
                  {
                     lineItem.cpState === CHALLENGE_PRICE_REJECTED &&
                     <div className='error-color'>CP Rejected</div>
                  }
                  {
                     lineItem.cpState === CHALLENGE_PRICE_ACCEPTED &&
                     <div className='success-color'>CP Accepted</div>
                  }
                  {
                     lineItem.CPAcceptValidFrom && lineItem.CPAcceptValidTo && lineItem.cpState !== CHALLENGE_PRICE_ACCEPTED &&
                     (lineItem.CPAcceptValidTo >= systemTime || (lineItem.CPAcceptValidTo < systemTime)) && 
                     // lineItem.cpState === CHALLENGE_PRICE_SENT &&
                     <div className='wt-120'>
                        <Timer from={lineItem.CPAcceptValidFrom} to={lineItem.CPAcceptValidTo} currentTime={systemTime} />
                     </div>
                  }
               </>}
            </div>
         }
         {isDesmet(lineItem.companyId) && <Fragment>
                        <ButtonT11
                         style = {{marginLeft:'20px'}}
                         onClick={() => {
                           this.handleOnClickForViewMaterialsBtn()
                        }}
                      >
                        View Materials
                      </ButtonT11>
                     </Fragment>}
         <div className="ml-5">
                  {!lineItem.isWithdrawBid && <SEOIcon className="curP fBold fs-18 wt-20 ht-30" onClick={(e) => { e.stopPropagation(); this.setState({ currentIndex: index }); this.setState({ openPopup: true }) }}></SEOIcon>}
                  {
                     this.state.currentIndex === index && this.state.openPopup && <OutsideClickHandler
                        onOutsideClick={() => {
                           this.setCurrentIndex(-1);
                        }}>
                        <PostBidPopup
                           biddingDetails={{ price: lineItem.price, tatValue: (lineItem.tat || {}).tatValue, tatUnit: (lineItem.tat || {}).tatUnit }}
                           index={index}
                           tripBids={tripBids}
                           fetchBids={fetchBids}
                           tripId={lineItem.id}
                           linerId={lineItem.linerId}
                           postBid={((data) => {
                              this.setCurrentIndex(-1);
                              if (rfq.type === 2 || rfq.type === 3 || rfq.type === 5 || [13, 14, 15, 16, 31].includes(rfq.type)) {
                                 postBid(lineItem.id, data, this.updateHandlingCharges(this.state.nextApiData));
                              } else {
                                 postBid(lineItem.id, data);
                              }
                           }).bind(this)}

                           submit={((data) => {
                              postChallengePrice(lineItem.id, data);
                           })}
                           challengePrice={lineItem.challengePrice}
                           isCounter={true}
                           hasTripBidEnd={(!lineItem.tripBidEnd || lineItem.tripBidEnd !== 0) && (systemTime > new Date(lineItem.tripBidEnd).getTime())}
                           isLot={lineItem.lotId}
                           trip_id={lineItem.id}
                           pricingBasisName={lineItem.pricingBasisName}
                           counterStatus={lineItem.counterStatus}
                           isAccessBidWithdrawn ={lineItem.isAccessBidWithdrawn}
                           isWithdrawBid ={lineItem.isWithdrawBid}
                           rfq={rfq}
                           isRilCPForm={isRilCPForm}
                           lineItem={lineItem}
                        />
                     </OutsideClickHandler>
                  }
               </div>
         {
            isRilCPForm && rfq.type !== 5 && 
            <div className={classNames("fs-14 section-sub-header-color flex-middle pr t-4 pl-15", {
               'wt-250 wt-250': (lineItem.isLoiSent && lineItem.isAccept === false) || (lineItem.isLoiSent && lineItem.isAccept === true),
               'wt-250': !((lineItem.isLoiSent && lineItem.isAccept === false) || (lineItem.isLoiSent && lineItem.isAccept === true))
            })}>
               <div className={classNames("flex flex-row flex-middle", {
                  'curNA op-7': !lineItem.challengePrice
               })}
               >
                  {rfq.type !== 5 &&  lineItem.cpState === CHALLENGE_PRICE_REJECTED && !lineItem.isWithdrawBid && <span className="br-5 pt-10 pb-10">
                     <PostBidFields
                        saveListOfObjects={(data, typeToAddRemoveUpdate) => { this.saveListOfObjects(data, typeToAddRemoveUpdate, '') }}
                        readOnly={(ROQUETTE.includes(lineItem.companyId) || [12].includes(rfq.type)) ? (lineItem.cpState !== CHALLENGE_PRICE_REJECTED) :
                           (lineItem.lotId ||
                              (!lineItem.challengePrice && !lineItem.tripBidEnd && !lineItem.relayEndTime) ||
                              lineItem.isLoiSent ||
                              (lineItem.challengePrice === lineItem.price) ||
                              lineItem.cpState === CHALLENGE_PRICE_SENT ||
                              (systemTime > new Date(lineItem.tripBidEnd).getTime()) || lineItem.isAccept === true || lineItem.isAccept === false) &&
                           ((rfq.challengePriceWithCounter === 0 || rfq.challengePriceWithCounter === null) && (!lineItem.tripBidEnd && (systemTime > new Date(lineItem.tripBidEnd).getTime()))) ||
                           (['737'].includes(lineItem.companyId) ? !(!lineItem.isLoiSent && lineItem.isAccept === false) : lineItem.counterStatus === COUNTER_ACCEPT || lineItem.challengePrice === undefined || lineItem.isAccept === true) && !lineItem.tripBidEnd && (systemTime > new Date(lineItem.tripBidEnd).getTime())

                           // &&
                           // (lineItem.relayEndTime && lineItem.relayEndTime <= systemTime)

                        }
                        biddingDetails={{
                           price: lineItem.boxPrice || lineItem.counterPrice,
                           allowBusinessVolume: lineItem.allowBusinessVolume,
                           transporterVol: lineItem.transporterVol,
                           showTat: lineItem.showTat,
                           rfqType: lineItem.rfqType,
                           tat: lineItem.tat || {
                              tatValue: lineItem.biddingDetails.tatValue,
                              tatUnit: {
                                 tatUnitName: lineItem.biddingDetails.tatUnitName,
                                 tatUnit: lineItem.biddingDetails.tatUnit
                              }
                           },
                           paymentBasis: paymentBasis,
                           containerFreeDay: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? (lineItem.leg &&  Object.keys(lineItem.leg).length > 0 && lineItem.leg.legs && lineItem.leg.legs.length > 0 && lineItem.leg.legs[0].containerFreeDay) : '',
                           exim_inco_terms: isAdani && lineItem.rfqType === 15 ? rfq.eximIncoTerms : undefined,
                           provider_bid_remarks: this.getAdaniEximLineItemWiseBidRemarks(lineItem,isAdani),
                           containerDaysHours: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? (lineItem.leg &&  Object.keys(lineItem.leg).length > 0 && lineItem.leg.legs && lineItem.leg.legs.length > 0 && lineItem.leg.legs[0].containerDaysHours) : '',
                           shippingLineName: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? (lineItem.leg &&  Object.keys(lineItem.leg).length > 0 && lineItem.leg.legs && lineItem.leg.legs.length > 0 && lineItem.leg.legs[0].shippingLineName) : '',
                           containerFree: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? (lineItem.leg &&  Object.keys(lineItem.leg).length > 0 && lineItem.leg.legs && lineItem.leg.legs.length > 0 && lineItem.leg.legs[0].containerFree) : '',
                           containerFeeDaysHours: (lineItem.rfqType === 5 || [13,14,15,16,31].includes(lineItem.rfqType)) ? lineItem.eximTatName : '',
                           bid_remarks: lineItem.bid_remarks || '',
                           bid_withdrawn_price: lineItem.bid_withdrawn_price,
                           priceInBaseCurrency: lineItem.priceInBaseCurrency,
                           priceInBaseCurrencySymbol: lineItem.priceInBaseCurrencySymbol,
                        }}
                        index={index}
                        submit={((data) => {
                           postChallengePrice(lineItem.id, data);
                        })}
                        challengePrice={lineItem.challengePrice}
                        isCounter={true}
                        hasTripBidEnd={(!lineItem.tripBidEnd || lineItem.tripBidEnd !== 0) && (systemTime > new Date(lineItem.tripBidEnd).getTime())}
                        isLot={lineItem.lotId}
                        trip_id={lineItem.id}
                        pricingBasisName={lineItem.pricingBasisName}
                        counterStatus={lineItem.counterStatus}
                        rfq={this.props.rfq}
                        isWithdrawBid ={lineItem.isWithdrawBid}
                        lineItem={lineItem}
                        systemTime={systemTime}
                     />
                  </span>}
                  {lineItem.isWithdrawBid && !lineItem.isAccessBidWithdrawn &&
                     <div className="fBold fs-14 danger-color pr col-1 t-8 tCenter pt-5 wt-95">
                        Bid Withdrawn 
                  </div>}
                  {lineItem.isAccessBidWithdrawn && lineItem.isWithdrawBid && <div className="fBold fs-14 green-color pr col-1 t-8 tCenter pt-5 wt-95">
                        Bid Revoked 
                  </div>}
               </div>
            </div>
         }
         {lineItem.isLoiSent && !lineItem.isAccept && lineItem.loiAcceptValidFrom && lineItem.loiAcceptValidTo &&
            // lineItem.loiAcceptValidTo >= new Date().getTime() && 
            lineItem.loiAcceptValidTo >= systemTime &&
            <div className="fs-14 lh-15p pl-15 wt-150">

               <div className="flex flex-between flex-middle">
               {!(rfq && !rfq.rfqDetails.acceptPartialSolution && ['737', ...STAR_CEMENT].includes(rfq.companyId)) &&
                  <>
                     <input type="checkbox" name="acceptorrejectlois" className="" checked={acceptOrRejectLoiList && acceptOrRejectLoiList.find((loi) => loi.trip_id === lineItem.id && ((HIKAL.includes(rfq.companyId) || [15,16,31].includes(rfq.type) || (rfq.shippingType !== 1 && [13,14].includes(rfq.type))) ? loi.linerId === lineItem.linerId : true))} onClick={(e) => { e.stopPropagation(); this.acceptClicked(e, lineItem) }} />
                     <span className="challenge-color curP pr-5 curP" onClick={(e) => { e.stopPropagation(); this.showAcceptPopup(lineItem) }}>Accept</span>
                     {!lineItem.l1AcceptMandatory && <>
                     <span className="pr-5 curP"> / </span>
                     <span className="pr-5 error-color curP" onClick={(e) => { e.stopPropagation(); this.showRejectPopup(lineItem) }}>Reject</span><br />
                     </>}
                  </>}
                  {/* <Open className=" theme-color underline curP " onClick={() =>{ this.props.openLineItemOverlay(lineItem); this.setCurrentIndex(index)}}/> */}
               </div>
               {
                  lineItem.loiAcceptValidFrom && lineItem.loiAcceptValidTo &&
                  // lineItem.loiAcceptValidTo >= new Date().getTime() &&
                  lineItem.loiAcceptValidTo >= systemTime &&
                  <div><Timer from={lineItem.loiAcceptValidFrom} to={lineItem.loiAcceptValidTo} currentTime={systemTime} /></div>
               }
            </div>}

         {lineItem.isLoiSent && !lineItem.isAccept &&
            // lineItem.loiAcceptValidTo < new Date().getTime() && 
            lineItem.loiAcceptValidTo < systemTime &&
            <div className="error-color pl-15 fs-14 wt-150">{`${rfq.type === 8 ? 'PO' : 'LOI'} Ignored` || ''}</div>
         }
          {lineItem.isLOICancelled && <div className="bg-lOI-cancelled pl-15 fs-14 wt-150">LOI Cancelled</div>}
         {lineItem.isLoiSent && lineItem.isAccept === true && <div className="challenge-color pl-15 fs-14 wt-150">Accepted</div>}
         {!lineItem.isLoiSent && lineItem.isAccept === false && <div className="error-color pl-15 fs-14 wt-150" >Rejected
            {rfq && ['737'].includes(rfq.companyId) && !rfq.rfqDetails.acceptPartialSolution && !lineItem.isLoiSent && lineItem.isAccept === false && !lineItem.counterPrice && <div className="orange-color fs-14 wt-150 mt-5">Please Enter the Counter Price</div>}
         </div>}
         {lineItem.loiCancelRemark && <div className="wt-120 mr-5 fs-12">
            <span className="caption-color">Remark :</span><div className="truncate-long-text" title={lineItem.loiCancelRemark}>{lineItem.loiCancelRemark}</div>
             </div> }
         {!lineItem.isLoiSent && lineItem.isAccept !== false && lineItem.isAccept !== true && <div className="pl-15 wt-150"><Status
            status={lineItem.status}
            hideText={true}
            rfqServiceType={lineItem.rfqServiceType}
         />
         </div>}
         {lineItem.isAcceptanceCeilingPrice && lineItem.biddingDetails.price && <AcceptanceOfCeilingPrice
        rfqId={lineItem.rfqId}
        tripId={lineItem. id}
        biddingDetails={lineItem.biddingDetails}
         submit={((data) => {
            postBid(lineItem.id, data);
         })}
         />}
      </div>
      </div>
      
         {/*rfq.type===2 && <div className="fs-12 fs-12 lh-15p theme-color fBold pl-20 pb-10 curP" onClick={(e) => this.handleShowCharges(true, lineItem, false)}>View Other Cost Charges</div>*/}
         {//this.state.showCharges && this.state.leg.id === lineItem.id &&
            (rfq.type === 2 || (rfq.type === 3 && (isAdani ? rfq.rfqDetails.secondaryContractType != 2 : true)) || rfq.type === 5 || [13,14,15,16,31].includes(rfq.type)) &&
            <HandlingCharges
               leg={lineItem} //this.state.leg}
               updateHandlingCharges={this.updateHandlingCharges}
               handleShowCharges={this.handleShowCharges}
               onHCChange={(hcIndex, value, name) => this.onHCChange(hcIndex, value, name, lineItem)}
               isEditBaseRate={true}
               isChargeEdit={this.state.isChargeEdit}
               handlePriceUpdate={(data, nextApiData, tat, unit) => this.handlePriceUpdate(data, lineItem, nextApiData, tat, unit)}
               includesOtherCharges={this.props.rfq.includesOtherCharges}
               showTat={lineItem.showTat}
               isRilCPForm={isRilCPForm}
               rfq={rfq}
               otherCostAcceptRejectCP={this.props.otherCostAcceptRejectCP}
				   currencyDetails={currencyDetails}
               currencyTypes={currencyTypes}
               handleChallengePrice={this.handleChallengePrice}
               LegIndex={index}
            />
         }
      </Fragment>
   }
   getRFQProductCategory = (lineItem) => {
      const name = getCompanyName();
      if (lineItem && lineItem.productCategoryType && name && name.includes(IS_RIL_RETAIL)) {
         const seletectCategory = PRODUCT_TYPE.filter((category) => { return (lineItem.productCategoryType === category.value); });
         let categories = '';
         (seletectCategory || []).map((category) => (
            categories = (categories.length > 0) ? (categories + ', ' + category.name) : category.name
         ));
         return categories
      }
      return '';
   }

   handleShowCharges = (show, lineItem, isChargeEdit) => {
      this.setState({
         leg: lineItem,
         showCharges: show,
         isChargeEdit: isChargeEdit
      })
   }

   onHCChange = (hcIndex, value, name, lineItem) => {
      let newHeadingCharge = lineItem.legs[0].multiModeHeadingCharges
      newHeadingCharge[hcIndex][name] = value;
      this.setState({
         leg: {
            ...lineItem,
            multiModeHeadingCharges: newHeadingCharge,
         }
      });
   }


    getEximIncoTerms(leg, rfq) {
       if (!leg || !rfq) return '';

       const isAdani = ADANI.includes(leg.companyId);
       const isRfqType = leg.rfqType === 15;

       return (isAdani && isRfqType) ? rfq.eximIncoTerms : '';
    }
    
    getAdaniEximLegWiseBidRemarks(leg, isAdani) {

       if (!leg) return '';

       const rfqType = [13,14,15,16,31].includes(leg.rfqType);

       if (isAdani && rfqType) {
          if (Object.keys(leg).length > 0 && Array.isArray(leg.legs) && leg.legs.length > 0) {
             return leg.legs[0].provider_bid_remarks || '';
          }
          return '';
       }

       return '';
    }

    getAdaniEximLegWiseproviderTatTime(leg, isAdani) {

       if (!leg) return '';

       const rfqType = [13,14,15,16,31].includes(leg.rfqType);

       if (isAdani && rfqType) {
          if (Object.keys(leg).length > 0 && Array.isArray(leg.legs) && leg.legs.length > 0) {
             return leg.legs[0].provider_tat_time || '';
          }
          return '';
       }

       return '';
    }

    getEximIncoTerms(leg, rfq) {
       if (!leg || !rfq) return '';

       const isAdani = ADANI.includes(leg.companyId);
       const isRfqType = leg.rfqType === 15;

       return (isAdani && isRfqType) ? rfq.eximIncoTerms : '';
    }

   updateStoreHandlingCharge = (leg) => {
      const { rfq } = this.props;
      const isExim = [13,14,15,16,31].includes(leg.rfqType);
      const isAdani = ADANI.includes(leg.companyId)
      const data = {
         "trip_id": leg.id,
         "rfq_id": leg.rfqId,
         multi_mode_heading_charges: Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].multiModeHeadingCharges || undefined,
         slabs: Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].secondaryModeOtherCharges  || undefined,
         total_km: leg.rfqType === 3 ? (parseFloat(leg.secKmRun || 0) - parseFloat(leg.secUptoKM || 0)) : '',
			total_bid_cost: leg.rfqType === 3 ? parseFloat(leg.other_cost || 0) : '',
         "po_loading": Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].poLoading || '',
         "po_destination": Object.keys(leg).length > 0 &&leg.legs.length > 0 && leg.legs[0] && leg.legs[0].poDestination || '',
			"price_usd": (leg.rfqType === 5 || isExim) ? Number(leg.price_usd || 0) : '',
         "price_inr": (leg.rfqType === 5 || isExim) ? (leg.price_inr || 0) : '',
         "price_secondary": (leg.rfqType === 5 || isExim) ? (leg.price_secondary || 0) : '',
         "estimated_time_of_departure_date": (leg.rfqType === 5 || isExim) ? Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].estimatedTimeOfDepartureDate || '' : undefined,
         "estimated_time_of_arrival_date": (leg.rfqType === 5 || isExim)  ? Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].estimatedTimeOfArrivalDate || '' : undefined,
         "shipping_line_name": ((leg.rfqType === 5 && HIKAL.includes(leg.companyId)) || isExim) ? Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].shippingLineName || '' : undefined,
         "liner_id": (([15,5].includes(leg.rfqType) && HIKAL.includes(leg.companyId)) || [16,31].includes(leg.rfqType) || (rfq.shippingType !== 1 && [13,14].includes(leg.rfqType))) ? Object.keys(leg).length > 0 && leg.linerId || (leg.legs.length > 0 && leg.legs[0] && leg.legs[0].linerId) || '' : undefined,
         "container_free_day": ((leg.rfqType === 5 && HIKAL.includes(leg.companyId)) || isExim) ? Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].containerFreeDay && Number(leg.legs[0].containerFreeDay) || '' : undefined,
         "container_days_hours": ((leg.rfqType === 5 && HIKAL.includes(leg.companyId)) || isExim) ? Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].containerDaysHours || '' : undefined,
         "extra_cost_per_km_price": leg.rfqType === 3 && ['999','872'].includes(leg.companyId) && (this.props.rfq.rfqDetails || {}).secondaryContractType === 1 && Number(leg.extraCostPerKmPrice || 0) || undefined,
         "vessel_routing_type": (ADANI.includes(leg.companyId) && isExim) ? (Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].vesselRoutingType || '' ) : undefined,
         "exim_inco_terms": this.getEximIncoTerms(leg,rfq),
         "provider_bid_remarks": this.getAdaniEximLegWiseBidRemarks(leg, isAdani)
      };
      if (this.props.rfq.includesOtherCharges) {
         data.price = leg.total;
         if(leg.rfqServiceType && leg.rfqServiceType === 5) {
            data.base_price = leg.base_price;
            data.base_price_usd = leg.base_price_usd;
            data.base_price_secondary = leg.base_price_secondary;
         }
      }
      if(rfq.type === 2 && ['737'].includes(rfq.companyId)) {
         if((rfq.rfqDetails || {}).serviceModes.includes(6)) {
            data.frequency = Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].frequency || undefined;
            data.origin_port_free_time = Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].originPortFreeTime || undefined;
            data.destination_port_free_time = Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].destinationPortFreeTime || undefined;
            data.ocean_transit_time = Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].oceanTransitTime || undefined;
            data.transshipment_ports = Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].transShipmentPorts || undefined;
         } else {
            data.origin_siding = Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].originSiding || undefined;
            data.destination_siding = Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].destinationSiding || undefined;
         }
         data.total_transit_time = Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].totalTransitTime || undefined;
      }
      return data;
   }

   updateHandlingCharges = (leg) => {
      console.log('leg21232131231:', leg)
      const isExim = [13,14,15,16,31].includes(leg.rfqType);
      const isAdani = ADANI.includes(leg.companyId)
      const { rfq } = this.props;
      const data = {
         "trip_id": leg.id,
         "rfq_id": leg.rfqId,
         // "multi_mode_heading_charges": [
         //    {
         //       "headingChargesValue": this.state.leg.legs[0].multiModeHeadingCharges[key].headingChargesValue,
         //       "headingChargesUnit": this.state.leg.legs[0].multiModeHeadingCharges[key].headingChargesValue,
         //       "headingChargesDescription": this.state.leg.legs[0].multiModeHeadingCharges[key].headingChargesDescription,
         //       "headingChargesMr": this.state.leg.legs[0].multiModeHeadingCharges[key].headingChargesMr,
         //       "headingChargesLpp": this.state.leg.legs[0].multiModeHeadingCharges[key].headingChargesLpp,
         //       "headingChargesBudget": Number(this.state.leg.legs[0].multiModeHeadingCharges[key].headingChargesBudget),
         //       "headingChargesCp": this.state.leg.legs[0].multiModeHeadingCharges[key].headingChargesCp,
         //       "cost_charge_id": this.state.leg.legs[0].multiModeHeadingCharges[key].cost_charge_id
         //    }
         // ]
         multi_mode_heading_charges: Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].multiModeHeadingCharges ? this.state.leg.legs[0].multiModeHeadingCharges : (leg && leg.legs.length > 0 && leg.legs[0].length && leg.legs[0].multiModeHeadingCharges ? leg.legs[0].multiModeHeadingCharges : undefined),
         slabs: Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].secondaryModeOtherCharges ? this.state.leg.legs[0].secondaryModeOtherCharges : (leg && leg.legs.length > 0 && leg.legs[0].length && leg.legs[0].secondaryModeOtherCharges ? leg.legs[0].secondaryModeOtherCharges : undefined),
         total_km: leg.rfqType === 3 ? (parseFloat(leg.secKmRun || 0) - parseFloat(leg.secUptoKM || 0)) : '',
			total_bid_cost: leg.rfqType === 3 ? parseFloat(leg.other_cost || 0) : '',
         "po_loading": Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].poLoading || '',
         "po_destination": Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].poDestination || '',
			"price_usd": (leg.rfqType === 5 || isExim)? Number(leg.price_usd || 0) : '',
         "price_inr": (leg.rfqType === 5 || isExim) ? (leg.price_inr || 0) : '',
         "price_secondary": (leg.rfqType === 5 || isExim) ? (leg.price_secondary || 0) : '',
         "estimated_time_of_departure_date": ([15,5,16,31].includes(leg.rfqType) || ([13,14].includes(leg.rfqType) && rfq.shippingType !== 1)) ? Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].estimatedTimeOfDepartureDate || '' : undefined,
         "estimated_time_of_arrival_date": ([15,5,16,31].includes(leg.rfqType) || ([13,14].includes(leg.rfqType) && rfq.shippingType !== 1)) ? Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].estimatedTimeOfArrivalDate || '' : undefined,
         "shipping_line_name": ((leg.rfqType === 5 && HIKAL.includes(leg.companyId)) || [15,16,31].includes(leg.rfqType) || ([13,14].includes(leg.rfqType) && rfq.shippingType !== 1)) ? Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].shippingLineName || '' : undefined,
         "liner_id": ((leg.rfqType === 5 && HIKAL.includes(leg.companyId)) || [15,16,31].includes(leg.rfqType) || ([13,14].includes(leg.rfqType) && rfq.shippingType !== 1)) ? Object.keys(this.state.leg).length > 0 && this.state.leg.linerId || (this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].linerId) || '' : undefined,
         "container_free_day": ((leg.rfqType === 5 && HIKAL.includes(leg.companyId)) || [15,16,31].includes(leg.rfqType) || ([13,14].includes(leg.rfqType) && rfq.shippingType !== 1)) ? Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].containerFreeDay && Number(this.state.leg.legs[0].containerFreeDay) || '' : undefined,
         "container_days_hours": ((leg.rfqType === 5 && HIKAL.includes(leg.companyId)) || isExim) ? Object.keys(this.state.leg).length > 0 && this.state.leg.legs.length > 0 && this.state.leg.legs[0] && this.state.leg.legs[0].containerDaysHours || '' : undefined,
         "extra_cost_per_km_price": leg.rfqType === 3 && ['999','872'].includes(leg.companyId) && (this.props.rfq.rfqDetails || {}).secondaryContractType === 1 && Number(leg.extraCostPerKmPrice || 0) || undefined,
         "vessel_routing_type": (ADANI.includes(leg.companyId) && isExim) ? (Object.keys(leg).length > 0 && leg.legs.length > 0 && leg.legs[0] && leg.legs[0].vesselRoutingType || '' ) : undefined,
         "exim_inco_terms": this.getEximIncoTerms(leg, rfq),
         "provider_bid_remarks": this.getAdaniEximLegWiseBidRemarks(leg, isAdani),
         "provider_tat_time":this.getAdaniEximLegWiseproviderTatTime(leg, isAdani),
      };
      if (this.props.rfq.includesOtherCharges) {
         data.price = leg.total;
         if(leg.rfqServiceType && leg.rfqServiceType === 5) {
            data.base_price = leg.base_price;
            data.base_price_usd = leg.base_price_usd;
            data.base_price_secondary = leg.base_price_secondary;
         }
      }
      this.setState({
         showCharges: false
      })
      return data;
      // this.props.updateHandlingCharges(data);
   }

   onChangeLoiRejectionRemarks = (e) => {
		this.setState({ loiRejectionReason: e.target.value });
   }

   withdrawAllBidConfirmation=(e)=>{
      const data = {
         trip_id: this.props && this.props.lineItems && this.props.lineItems[0].id,
         rfq_id : this.props && this.props.rfq && this.props.rfq.id
      }
      if (e && e.preventDefault && e.stopPropagation) {
         e.stopPropagation();
         e.preventDefault();
      }
      this.props.vendorWithDrawBid(data);
      this.setState({
         isShowWithDraw: false
      })
   }

   isHideWithDrawBidPopUp =(e)=>{
      if (e && e.preventDefault && e.stopPropagation) {
         e.stopPropagation();
         e.preventDefault();
      }
      this.setState({
         isShowWithDraw: false
      })
   }

   onChangeCounterPrice = (e) => {
      this.setState({ counterPrice: e.target.value });
   }

   handleModalPopupOpen = () => {
      this.setState((previousState) => {
        let updatepreviousState = {
          ...previousState,
          isModalPopupOpen: true,
        };
        return updatepreviousState;
      });
      setItemToSessionStorage("isMaterialsViewAtleastOneTime",true);
   };

    handleOnClickForViewMaterialsBtn = () => {
       const { match } = this.props;
       const rfqId = match.params.id
       this.handleGetProviderMaterialPackingDetails(rfqId)
    };
  
    handleModalPopupClose = () => {
      this.setState((previousState) => {
        let updatepreviousState = {
          ...previousState,
          isModalPopupOpen: false,
        };
        return updatepreviousState;
      });
    };

    handleGetMaterialPackingList = ()=>{
      const {rfq} = this.props;
      let material_packing_list = []
      material_packing_list = rfq.rfqDetails.material_packing_list
      return material_packing_list 
    }

    handleGetProviderMaterialPackingDetails = (rfqId) => {
       const { dispatch } = this.props;

       const queryParams = {
          rfqId
       }

       const onSuccess = (link) => {
          console.log('link:', link)
          this.setState((previousState) => {
             let updatepreviousState = {
                ...previousState,
                providerMaterialPackingDetailsLink: link,
             };
             return updatepreviousState;
          }, () => {
            //  this.handleModalPopupOpen()
          });
       }

       this.handleModalPopupOpen()

       dispatch({
          type: GET_PROVIDER_MATERIAL_PACKING_DETAILS,
          queryParams,
          onSuccess
       });

    };

    handleDownloadProviderMaterialPackingDetailsLink = (url) => {
      const { providerMaterialPackingDetailsLink } = this.state;
      const link = document.createElement("a");
      link.href = !!url ? url : providerMaterialPackingDetailsLink;
      link.setAttribute("download", true);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    downloadUploadedFile = (fileName) => {
      const { dispatch } =  this.props;
      dispatch({
         type: DOWNLOAD_UPLOADED_FILE,
         param: {
            fileName
         }
      })
   }
 
   handleDeleteLeg = (lineItem) => {
      const { additionalLineItems } = this.state;
      const findLegIndex = (additionalLineItems || []).findIndex(el => ((el.linerId === lineItem.linerId) && (lineItem.id === el.id)));
      if(findLegIndex > -1) {
         additionalLineItems.splice(findLegIndex, 1);
      }
      this.setState({
         additionalLineItems
      });
      // setItemToLocal('additionalLineItems', additionalLineItems);
   }

   getStopDetails = (stops, index) => {
      const { rfq } = this.props;
      const stopData = stops[index];
      let stopLabel = '';
      if(stopData.state) {
         stopLabel = `, ${stopData.state}`
      }
      if(rfq.type === 12 && ADANI.includes(rfq.companyId)) {
         stopLabel += `, ${stopData.country}`
      }
      if(stopData.pincode) {
         stopLabel += `, (${stopData.pincode})`
      }
      return stopLabel;
   }

    renderAddLinersExpceptAwl = (biddingStage, rfq) => {
       if (!biddingStage.inProgress || !rfq) return false;

       const { companyId, type, shippingType, eximIncoTerms } = rfq;

       const isExim = type === 15;
       const isAdani = ADANI.includes(companyId);
       const isFOB = eximIncoTerms === "FOB";
       const isCIF = eximIncoTerms === "CIF";

       if (isAdani && isExim && (isFOB || isCIF)) {
          return false;
       }

       return (
          HIKAL.includes(companyId) ||
          isExim ||
          (shippingType !== 1 && [13, 14].includes(type))
       );
    }

    renderAddLinersForAwl = () => {
       const { biddingStage , rfq} = this.props
       if (!biddingStage.inProgress || !rfq) return false;

       const { companyId, type, eximIncoTerms } = rfq;

       const isExim = type === 15;
       const isAdani = ADANI.includes(companyId);
       const isCIF = eximIncoTerms === "CIF";

       if (isAdani && isExim && isCIF) {
          return true;
       }
       return false
       
    }

    handleAddLiners = (leg, legKey) => {
       const { legLiners = {}, additionalLineItems = [] } = this.state;
       const linersForLeg = legLiners[legKey] || [];

       if (linersForLeg.length === 0) {
          alert("Please select at least one Liner");
          return;
       }

       const additionalLineItemsCopy = [...additionalLineItems];

       linersForLeg.forEach(liner => {
          const lineItemCopy = {
             ...leg,
             isNew: true,
             linerId: liner.id,
             _sourceLinerId: leg.linerId,
             price: '',
             priceUSD: '',
             status: '',
             priceSecondary: '',
             legs: [
                {
                   ...leg.legs[0],
                   estimatedTimeOfArrivalDate: '',
                   estimatedTimeOfDepartureDate: '',
                   containerFreeDay: '',
                   vesselRoutingType: '',
                   shippingLineName: liner.name,
                   provider_bid_remarks: '',
                   provider_tat_time: '',
                   tripCost: 0,
                   trip_cost_usd: 0,
                   trip_cost_secondary: 0,
                   multiModeHeadingCharges: (leg.legs[0].multiModeHeadingCharges || [])
                      .filter(el => !el.transporterAddedCost && !el.isNewlyAdded)
                      .map(el => ({
                         ...el,
                         headingChargesCp: '',
                         headingChargesCp_inr: '',
                         headingChargesCp_secondary: '',
                         headingChargesCp_usd: ''
                      }))
                }
             ]
          };

          additionalLineItemsCopy.push(lineItemCopy);
       });

       this.setState(prev => ({
          additionalLineItems: additionalLineItemsCopy,
          legLiners: {
             ...prev.legLiners,
             [legKey]: []
          }
       }));
    };

    renderAddLinersForAwlEximCIF = (rfq, leg, LinersList) => {
       const { seaAndAirLines } = this.props;
       const { legLiners = {} } = this.state;
       const legKey = leg.linerId || leg.id;

       return (
          <div className="mt-5 bg-white mb-5 fRight">
             <div className="inBlock">
                <Select
                   className="wt-300"
                   placeholder="Select Liners"
                   isMulti
                   value={legLiners[legKey] || []}
                   options={
                      ((rfq.rfqDetails || {}).serviceCategoryType === 1
                         ? (seaAndAirLines?.sea || [])
                         : (seaAndAirLines?.air || [])
                      ).filter(el =>
                         !(LinersList || []).includes(el.id)
                      )
                   }
                   getOptionLabel={(option) => option.name}
                   getOptionValue={(option) => option.id}
                   onChange={(option) => {
                      this.setState(prev => ({
                         legLiners: {
                            ...prev.legLiners,
                            [legKey]: option
                         }
                      }));
                   }}
                />
             </div>

             <button
                className="ht-30 ml-20 br-5 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 wt-200 inBlock"
                onClick={() => this.handleAddLiners(leg, legKey)}
             >
                Add Liners
             </button>
          </div>
       );
    };

   //  renderLineItemsList = (lineItems, extralineItems, isAwlEximCIF, biddingStage, isCancelled, isRilCPForm, categories, vehicleTypesList, LinersList, loadingTrips) => {
   //     const { openLineItem, hideLineItem, pricingBasis, paymentCycles, currencyTypes, rfq, currentLineItem } = this.props;

   //     if ((!lineItems || lineItems.length === 0) && !loadingTrips) {
   //        return <></>;
   //     }

   //     const itemsToRender = biddingStage['inProgress']
   //        ? ((lineItems || []).length > 0 && (isAwlEximCIF ? (() => {
   //             const merged = [];
   //             (lineItems || []).forEach(li => {
   //                merged.push(li);
   //                (extralineItems || []).forEach(el => {
   //                   if (el.id === li.id && el._sourceLinerId === li.linerId) merged.push(el);
   //                });
   //             });
   //             return merged;
   //          })() : [...lineItems, ...extralineItems]))
   //        : lineItems;

   //     return (itemsToRender || []).map((lineItem, index) => {
   //        return <div key={isAwlEximCIF ? `${lineItem.id}-${lineItem.linerId || index}` : index}>
   //           {
   //              isCancelled
   //                 ?
   //                 <React.Fragment>
   //                    {this.getBodyForBidCompleted(lineItem, index, categories, isRilCPForm)}
   //                 </React.Fragment>
   //                 :
   //                 <React.Fragment>
   //                    {
   //                       this.checkIfBidStarted(lineItem, biddingStage, this.props.systemTime) &&
   //                       this.getBodyForBidStarted(lineItem, index, categories, vehicleTypesList, isRilCPForm, LinersList)
   //                    }
   //                    {
   //                       biddingStage['yetToStart'] && !lineItem.event_contract && this.getBodyForBidNotStarted(lineItem, index, categories)
   //                    }
   //                 </React.Fragment>
   //           }
   //           {
   //              biddingStage['complete'] && this.getBodyForBidCompleted(lineItem, index, categories, isRilCPForm, true)
   //           }
   //           {currentLineItem && currentLineItem.id === lineItem.id && openLineItem && <LineItemDetail
   //              lineItem={lineItem}
   //              key="lineItemDetail"
   //              pricingBasis={pricingBasis}
   //              paymentCycles={paymentCycles}
   //              openLineItem={lineItem}
   //              hideLineItem={hideLineItem}
   //              currencyTypes={currencyTypes}
   //              rfq={rfq}
   //           />}
   //        </div>
   //     });
   //  };


    renderLineItemsList = (lineItems, extralineItems, isAwlEximCIF, biddingStage, isCancelled, isRilCPForm, categories, vehicleTypesList, LinersList, loadingTrips) => {
       const { openLineItem, hideLineItem, pricingBasis, paymentCycles, currencyTypes, rfq, currentLineItem } = this.props;

       if ((!lineItems || lineItems.length === 0) && !loadingTrips) {
          return <></>;
       }

       const itemsToRender = biddingStage['inProgress']
          ? ((lineItems || []).length > 0 && (isAwlEximCIF ? (() => {
               const merged = [];
               (lineItems || []).forEach(li => {
                  merged.push(li);
                  (extralineItems || []).forEach(el => {
                     if (el.id === li.id && el._sourceLinerId === li.linerId) merged.push(el);
                  });
               });
               return merged;
            })() : [...lineItems, ...extralineItems]))
          : lineItems;

       return (itemsToRender || []).map((lineItem, index) => {
          return <div key={isAwlEximCIF ? `${lineItem.id}-${lineItem.linerId || index}` : index}>
             {
                isCancelled
                   ?
                   <React.Fragment>
                      {this.getBodyForBidCompleted(lineItem, index, categories, isRilCPForm)}
                   </React.Fragment>
                   :
                   <React.Fragment>
                      {
                         this.checkIfBidStarted(lineItem, biddingStage, this.props.systemTime) &&
                         this.getBodyForBidStarted(lineItem, index, categories, vehicleTypesList, isRilCPForm, LinersList)
                      }
                      {
                         biddingStage['yetToStart'] && !lineItem.event_contract && this.getBodyForBidNotStarted(lineItem, index, categories)
                      }
                   </React.Fragment>
             }
             {
                biddingStage['complete'] && !this.checkIfBidStarted(lineItem, biddingStage, this.props.systemTime) && this.getBodyForBidCompleted(lineItem, index, categories, isRilCPForm, true)
             }
             {currentLineItem && currentLineItem.id === lineItem.id && openLineItem && <LineItemDetail
                lineItem={lineItem}
                key="lineItemDetail"
                pricingBasis={pricingBasis}
                paymentCycles={paymentCycles}
                openLineItem={lineItem}
                hideLineItem={hideLineItem}
                currencyTypes={currencyTypes}
                rfq={rfq}
             />}
          </div>
       });
    };


    checkIfBidStarted(lineItem, biddingStage, systemTime) {
       const hasLegs = lineItem.legs && lineItem.legs.length > 0;
       const firstLeg = hasLegs ? lineItem.legs[0] : null;

       const inProgress = biddingStage['inProgress'];

       const roundTripActive =
          hasLegs &&
          firstLeg.round_trip_count > 0 &&
          firstLeg.round_bidding_start &&
          firstLeg.round_bidding_end &&
          systemTime > firstLeg.round_bidding_start &&
          systemTime < firstLeg.round_bidding_end;

       const tripBiddingActive =
          (lineItem.trip_bidding_end && lineItem.trip_bidding_end >= systemTime) ||
          (lineItem.tripBidEnd && new Date(lineItem.tripBidEnd).getTime() > 0 && systemTime < new Date(lineItem.tripBidEnd).getTime());

       const yetToStartWithContract =
          biddingStage['yetToStart'] && lineItem.event_contract;

       return inProgress || roundTripActive || tripBiddingActive || yetToStartWithContract;
    }
   
   render() {
      const { rfq, biddingStage, loadingTrips, pricingBasis, paymentCycles, currentLineItem, hideLineItem, openLineItem, lineItem, courierZones, courierPostBid, otherCharges, courierAcceptOrRejectLoiList, postBidAll, courierAcceptOrRejectCPList, additionalZoneList, currencyTypes, warehouseList, systemTime, seaAndAirLines, postDisposalBid, bidSubmitList, transporterBiddedCount} = this.props;
      let { lineItems,
         vehicleTypesList
      } = this.props;
      const originalItems = {...lineItems};
      // lineItems = lineItems.length===0 ? STATIC_DATA : lineItems;
      const { selectedSubmitButtons, acceptOrRejectLoiList, leg, showCharges, tripCounter, counterPrice, additionalLineItems,
         isModalPopupOpen
      } = this.state;
      const name = getCompanyName();
      const categories = (name && name.includes(IS_RIL_RETAIL));
      const isRilCPForm = !(this.props.rfq && this.props.rfq.companyId && this.props.rfq.companyId === IS_CP_TYPE_RFQ);
      const isCancelled = (this.props.rfq && (this.props.rfq.rfqStatus === 99))
      const isAwlEximCIF = ADANI.includes(rfq.companyId) && rfq.type === 15 && rfq.eximIncoTerms === "CIF";
      // const secKmRun = lineItems.map(e => e.secKmRun)
      let extralineItems = [];
      let LinersList = [];
      // if(additionalLineItems.length > 0) {
      //    (additionalLineItems || []).map(el => {
      //       const lineItem = (lineItems || []).find(elItem => elItem.linerId === el.linerId);
      //       if(!lineItem) {
      //          extralineItems.push(el);
      //       }
      //    })
      // }
      if(HIKAL.includes(rfq.companyId) || [15,16,31].includes(rfq.type) || (rfq.shippingType !== 1 && [13,14].includes(rfq.type))) {
         const lineItemLiners = [];
         (lineItems || []).forEach(line => {
            if(line.linerId)
            lineItemLiners.push(line.linerId);
         });
         LinersList = [...lineItemLiners];
         (additionalLineItems || []).forEach(el => {
            if(!lineItemLiners.includes(el.linerId)) {
               LinersList.push(el.linerId);
               extralineItems.push(el);
            }
         })
      }
      return (
         <div className={classNames("box-shadow border-light br-5 pr", {
            'mt-25' : rfq.serviceType !== 3,
            'mt-10' : rfq.serviceType === 3
         })}>


            <ModalT1
               isOpenState={isModalPopupOpen}
               handleOnClickForClose={this.handleModalPopupClose}
            >
               <ModalCardT4
                  title={"Material Details"}
                  handleOnClickForDownloadBtn = {this.handleDownloadProviderMaterialPackingDetailsLink}
               >
                  <Fragment>
                     <Fragment>
                        <div 
                          className='section-sub-header-color fBold fs-16'
                        >
                           Special Instructions :
                        </div>
                        <div>
                           {((rfq.rfqDetails || {}).supplier_instruction) || '-'}
                        </div>
                        {/* <Spacer spacing={"3px"} />
                        <div 
                          className='section-sub-header-color fBold fs-16'
                        >
                           Packing List Document :
                        </div>
                        <div>
                           {((rfq.rfqDetails || {}).supplier_docs||[]).map((ele,ind)=>{
                                return <Fragment key = {ind}>
                                 <div
                                 className='fs-16 curP pt-5' 
                                 onClick={()=>{
                                    this.downloadUploadedFile(ele.name)
                                 }}
                                 >
                                { ele.name}
                                 </div>
                                </Fragment>
                           })}
                        </div> */}
                        <Spacer spacing={"4px"} />
                     </Fragment>
                     <MaterialDetailsTable
                        selectMaterialPackingList={this.handleGetMaterialPackingList()}
                     />
                  </Fragment>
               </ModalCardT4>
            </ModalT1>

				{this.state.isLoiAcceptPopupShown && <ConfirmationPopup text={'Are You Sure You Want To Accept??'} onConfirm={this.acceptLoi} onCancel={this.hideAcceptPopup} />}
            {this.state.isLoiRejectPopupShown && <ConfirmationPopup text={(this.props.rfq.companyId==="737")?"" :'Are You Sure You Want To Reject?'} onConfirm={this.state.acceptOrRejectLoiList.length > 0 ? this.rejectAllLoi : this.rejectLoi} onCancel={this.hideRejectPopup} loiRejectionReason ={this.state.loiRejectionReason} onChangeLoiRejectionRemarks={this.onChangeLoiRejectionRemarks} companyId={this.props.rfq.companyId} tripCounter={tripCounter} counter={counterPrice} onChangeCounterPrice={this.onChangeCounterPrice}/>}           
            {this.state.isShowWithDraw && (rfq.rfqTypeLtc || rfq && !rfq.rfqDetails.acceptPartialSolution) && <ConfirmationPopup text={"Are you sure you want to withdraw all lanes?"} onCancel={this.isHideWithDrawBidPopUp} onConfirm={this.withdrawAllBidConfirmation}/>}
            {/* { rfq.serviceType === 3 && <div className="mb-10 fSemibold flex pt-20 pl-20"> <div className="mr-10">Display As : </div>
               <div className="mr-10"><input type="checkbox" className="" checked={!this.state.isTable} onClick={(e) => { this.setState({ isTable: false }) }} /> List  </div>
               <div><input type="checkbox" className="" checked={this.state.isTable} onClick={(e) => { this.setState({ isTable: true }) }} /> Table </div>
            </div>} */}
            {![9].includes(rfq.type) && <>
            {this.state.isTable || rfq.serviceType === 3  ? 
               <Fragment>
                  {/* {this.renderTable()} */}
                  <CourierLineItems 
                     lineItems={lineItems || []}
                     courierZones={courierZones}
                     courierPostBid={courierPostBid}
                     biddingStage={biddingStage}
                     otherCharges={otherCharges}
                     systemTime={this.props.systemTime}
                     acceptOrRejectLoiList={courierAcceptOrRejectLoiList}
                     acceptOrRejectCPList={courierAcceptOrRejectCPList}
                     setAcceptOrRejectLoiList={this.props.setAcceptOrRejectLoiList}
                     postBidAll={postBidAll}
                     isRilCPForm={isRilCPForm}
                     postChallengePrice={this.props.postChallengePrice}
                     acceptRejectCP={this.props.acceptRejectCP}
                     fetchBids={this.props.fetchBids}
                     tripBids={this.props.tripBids}
                     isCourierTermAccepted={this.props.isCourierTermAccepted}
                     additionalZoneList={additionalZoneList}
                  />
               </Fragment> :
            <StickyContainer>
               {(rfq.rfqDetails.acceptPartialSolution === false || rfq.rfqDetails.biddingPercentageSolution) && biddingStage['inProgress'] && ((rfq.companyId === "737" && rfq.rfqTypeLtc === "LTC" && !rfq.rfqDetails.acceptPartialSolution) ? !(lineItems[0] || {}).isWithdrawBid : true) &&
                  <Sticky>
                     {({
                        style, isSticky
                     }) => (
                           <header>
                              {rfq && rfq.rfqDetails && <div className={(rfq.rfqDetails.biddingPercentageSolution ? (transporterBiddedCount >= rfq.percentage_trips_count) : rfq.rfqDetails.allBidsCompleted) ? classNames("mb-10 bg-success tCenter", {
                                 'pb-10 pt-10 box-shadow': isSticky,
                                 'pb-5 pt-5': !isSticky
                              }) : classNames("mb-10 bg-error tCenter", {
                                 'pb-10 pt-10 box-shadow': isSticky,
                                 'pb-5 pt-5': !isSticky
                              })}
                                 style={{ ...style, marginTop: isSticky ? '60px' : 0, zIndex: 1 }}
                              >
                                 {rfq && rfq.rfqDetails && !rfq.rfqDetails.acceptPartialSolution && <div className="fBold fs-14 white-color pl-15">{rfq.rfqDetails.allBidsCompleted ? "All Bids Posted Successfully" : "* It is mandatory to bid for all trips"}</div>}
                                 {rfq.rfqDetails.biddingPercentageSolution && <div className="fBold fs-14 white-color pl-15">{ (transporterBiddedCount >= rfq.percentage_trips_count) ? "Bids Posted Successfully " : `* It is mandatory to bid for atleast ${rfq.percentage_trips_count} ${rfq.type == 9 ? 'lanes' : 'trips'}`}</div>}
                              </div>}
                           </header>
                        )}
                  </Sticky>}
               {
                  (biddingStage['inProgress'] || (biddingStage['yetToStart'] && ((lineItems || [])[0] || {}).event_contract)) && this.getHeaderForBidStarted(selectedSubmitButtons.length, lineItems)
               }
               {
                  biddingStage['yetToStart'] && !(((lineItems || [])[0] || {}).event_contract) && this.getHeaderForBidNotStarted(lineItems)
               }
               {
                  biddingStage['complete'] && this.getHeaderForBidCompleted(isRilCPForm, acceptOrRejectLoiList.length, lineItems, rfq)
               }
               {
                  this.renderLineItemsList(lineItems, extralineItems, isAwlEximCIF, biddingStage, isCancelled, isRilCPForm, categories, vehicleTypesList, LinersList, loadingTrips)
               }
               {this.renderAddLinersExpceptAwl(biddingStage, rfq) && <div className="mt-5 bg-white mb-5 fRight">
                  <div className='inBlock'>
                     <Select
                        className="wt-300"
                        placeholder="Select Liners"
                        isMulti
                        value={this.state.liners}
                        options={((rfq.rfqDetails || {}).serviceCategoryType === 1 ? ((seaAndAirLines || {}).sea || []) : ((seaAndAirLines || {}).air || [])).filter(el => !LinersList.includes(el.id))}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        onChange={(option) => {
                           this.setState({ liners: option }) 
                        }}
                     />
                  </div>
                  <button
                     className="ht-30 ml-20 br-5 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20 wt-200 inBlock"
                     onClick={() => {
                        const { additionalLineItems } = this.state;
                        const lineItemCopy = JSON.parse(JSON.stringify(this.props.lineItems[this.props.lineItems.length-1]));
                        let lineItem = lineItemCopy;
                        lineItem.isNew = true;
                        if(ADANI.includes(lineItem.companyId)) {
                           lineItem.price = '';
                           (lineItem.legs[0]['multiModeHeadingCharges'] || []).forEach(el => {
                              el['headingChargesCp'] = '';
                              el['headingChargesCp_inr'] = '';
                              el['headingChargesCp_secondary'] = '';
                              el['headingChargesCp_usd'] = '';
                           })
                        }
                        delete lineItem.linerId;
                        (this.state.liners || []).forEach(liner => {
                           (lineItem.legs[0] || {}).shippingLineName = liner.name;
                           lineItem.linerId = liner.id;
                           if(((lineItem.legs[0] || {}).multiModeHeadingCharges || []).length > 0){
                              lineItem.legs[0].multiModeHeadingCharges = (lineItem.legs[0].multiModeHeadingCharges || []).filter(el => !el.transporterAddedCost);
                           }
                           additionalLineItems.push(JSON.parse(JSON.stringify(lineItem)));
                        });
                        this.setState({ 
                           additionalLineItems, 
                           liners: []
                        });
                        //setItemToLocal('additionalLineItems', additionalLineItems);
                     }}
                  >Add Liners</button>
               </div>}
            </StickyContainer>
            } </> }
            {rfq.type == 9 &&
               <DisposalProductLineItem
                  trips={lineItems}
                  biddingStage={biddingStage}
                  systemTime={this.props.systemTime}
                  postBidAll={postBidAll}
                  readyToPostBid={this.props.readyToPostBid}
                  postDisposalBid={postDisposalBid}
                  rfq={rfq}
                  bidSubmitList={bidSubmitList}
               />
            }
            {
               (!lineItems && lineItems.length === 0) &&
               <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No Line Item Has Been Added</div>
            }

            {/* {showCharges && <Overlay>
               <div className="box-shadow br-5 pr flex">
                  <div className="wt-100p pt-20 pb-20 ht-400 overflowAuto">
                     <div className="pl-20 pr-20 pb-50">
                        <div className="flex flex-middle border-bottom-light-2 pb-10 mb-30">
                           <Heading text="Heading charges" className="flex-1" />
                           <div className="flex flex-between" >
                              <div className="flex mr-20 curP" onClick={() => this.handleShowCharges(false, {})}>
                                 <CloseIcon className="theme-fill ht-12 wt-12 mr-5" />
                                 <span className="theme-color fs-14 fBold">Close</span>
                              </div>
                           </div>
                        </div>
                        <div className="mb-40">
                           <div className="flex ht-30">
                              <div className="wt-5p ht-20 mr-10">
                                 <div className="fSemibold fs-18 header-medium-color mb-5"></div>
                              </div>
                              <div className="wt-17p ht-20">
                                 <div className="fSemibold fs-18 header-medium-color mb-5 ml--10">Cost Head</div>
                              </div>
                              <div className="wt-12p ht-20 ml--59">
                                 <div className="fSemibold fs-18 header-medium-color mb-5 ml-13">Costing Type</div>
                              </div>
                              <div className="wt-12p ht-20">
                                 <div className="fSemibold fs-18 header-medium-color mb-5 ml-33">Description</div>
                              </div>
                              <div className="wt-12p ht-20 mr-5">
                                 <div className="fSemibold fs-18 header-medium-color mb-5 ml-50">MR</div>
                              </div>
                              <div className="wt-12p ht-20 mr-5">
                                 <div className="fSemibold fs-18 header-medium-color mb-5 ml-63">LPP</div>
                              </div>
                              <div className="wt-12p ht-20 mr-5">
                                 <div className="fSemibold fs-18 header-medium-color mb-5 ml-80">Budget</div>
                              </div>
                              <div className="wt-12p ht-20 mr-5">
                                 <div className="fSemibold fs-18 header-medium-color mb-5 ml-">CP</div>
                              </div>
                           </div>
                           <div className="">
                              {
                                 leg.legs != undefined && leg.legs.length > 0 && leg.legs[0].multiModeHeadingCharges && leg.legs[0].multiModeHeadingCharges.length > 0 ? leg.legs[0].multiModeHeadingCharges.map((hc, hcindex) => (
                                    <>
                                       <Fragment>
                                          <div key={`hc_${hcindex}`} className="flex mb-10 ht-40">
                                             <div className="wt-5p ht-30 mr-10 mt-12">
                                                {
                                                   hcindex + 1
                                                }
                                             </div>
                                             <div className="wt-20p ht-30 ml-5">
                                                <Input className="disabled" placeholder="Charges" value={hc.headingChargesValue} onChange={(e) => this.onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesValue" />
                                             </div>
                                             <div className="wt-20p ht-30 ml-5">
                                                <Dropdown
                                                   items={[...COST_TYPE]}
                                                   selectedItem={COST_TYPE.find(pricingBasis => { return hc.headingChargesUnit === pricingBasis.value })}
                                                   name="headingChargesUnit"
                                                   onSelect={(e) => this.onHCChange(hcindex, e.value, 'headingChargesUnit')}
                                                   displayKey="name"
                                                   className="flex-1"
                                                   label="Select Cost Type"
                                                   className="disabled"
                                                />
                                             </div>
                                             <div className="wt-20p ht-30 ml-5 disabled">
                                                <Input className="disabled" placeholder="Desc" value={hc.headingChargesDescription}
                                                   onChange={(e) => this.onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesDescription" />
                                             </div>
                                             <div className="wt-20p ht-30 ml-5">
                                                <Input className="disabled" placeholder="MR" value={hc.headingChargesMr} onChange={(e) => this.onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesMr" />
                                             </div>
                                             <div className="wt-20p ht-30 ml-5">
                                                <Input className="disabled" placeholder="LPP" value={hc.headingChargesLpp} onChange={(e) => this.onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesLpp" />
                                             </div>
                                             <div className="wt-20p ht-30 ml-5">
                                                <Input placeholder="Budget" value={hc.headingChargesBudget} onChange={(e) => this.onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesBudget" />
                                             </div>
                                             <div className="wt-20p ht-30 ml-5">
                                                <Input className="disabled" placeholder="CP" value={hc.headingChargesCp} onChange={(e) => this.onHCChange(hcindex, e.target.value, e.target.name)} name="headingChargesCp" />
                                             </div>

                                          </div>
                                       </Fragment>

                                    </>
                                 )) : 'No Heading charge added'
                              }
                              <div className="wt-20p ht-30 ml-5 mt-40 ml-500">
                                 <button
                                    className="ht-40 br-5 white-color bg-theme fs-16 fBold pl-30 pr-30 mr-20"
                                    onClick={() => this.updateHandlingCharges(leg)}
                                 >Save</button>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </Overlay>} */}
         </div>
      )
   }
}

export default connect(null, null)(withRouter(LineItemsTable));
